//Principais
import { formatDate } from '@angular/common';
import { Component, inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from "rxjs";
//Metodos
import { Perfil } from "src/app/shared/enums/Perfis/Perfis";
import { Diretoria } from "src/app/shared/models/diretoria/Diretoria";
import { Escola } from "src/app/shared/models/escola/Escola";
import { FiltroPadrao } from "src/app/shared/models/filtro-padrao/filtroPadrao";
import { FinalizaJornadaOutroDia, JornadaJustificativaDistancia, JornadaJustificativaTempoRegistro } from "src/app/shared/models/psicologo/JornadaJustificativaEntradaSaida";
import { JornadaPsicologo, JornadaPsicologoAtividade, JornadaPsicologosInserir } from "src/app/shared/models/psicologo/JornadaPsicologo";
import { JornadaPsicologoAntiga } from "src/app/shared/models/psicologo/JornadaPsicologoAntiga";
import { PainelAtividadePsicologo } from "src/app/shared/models/psicologo/PainelAtividadePsicologo";
import { AtribuicaoLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";
//Services
import { PageBreadcrumb } from "components/breadcrumb/breadcrumb.component";
import { AuthService } from 'src/app/shared/auth/services/auth.service';
import { JornadaJustificativaEntradaSaida } from "src/app/shared/models/psicologo/JornadaJustificativaEntradaSaida";
import { Psicologo } from "src/app/shared/models/psicologo/Psicologo";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { EscolaService } from "src/app/shared/services/escola.service";
import { FiltroService } from "src/app/shared/services/filtro.service";
import { RelogioPontoService } from "src/app/shared/services/modal-relogioPonto.service";
import { PsicologoService } from "src/app/shared/services/psicologo.service";
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { dataNaoFuturaValidator, dataRetroativaLimiteValidator } from 'src/app/shared/validations/genericValidators';
import { Tabulator } from 'tabulator-tables';
import { Polo } from 'src/app/shared/models/polo/Polo';
import { AtividadePsicologoDeslocamento } from 'src/app/shared/models/atividade-psicologo/atividade-psicologo-deslocamento';
import { MapsService } from 'src/app/shared/services/maps.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { cpfsIguais } from 'src/app/shared/utils/cpf.util';
import { ngSelectSearchFnPorLabel } from 'src/app/shared/utils/ng-select-search.util';
import {
  extrairCodigoJornada,
  jornadaEstaAprovada,
  jornadaEstaAtiva,
  jornadasSobrepoemHorario,
  mesclarJornadaAtivaNaListagem,
  mesclarJornadasPorCodigo,
  possuiCheckoutEfetivo
} from 'src/app/shared/utils/jornada-em-aberto-modal';

@Component({
  templateUrl: './painel-atividade-psicologo.component.html',
  styleUrls: ['./painel-atividade-psicologo.component.scss'],
  standalone: true,
  imports: [angularCommonImports, convivaCommonImports, libsCommonImports]
})

export class PagePainelAtividadesPsicologoComponent implements OnInit {
  // #162968 — Bypass temporário até 15/08/2026 (reinserção 06–08/07); depois volta a 15 dias.
  private readonly limiteDiasJornadaRetroativa = 15;
  private readonly dataFimBypassLimiteRetroativa = new Date(2026, 7, 15); // 15/08/2026 (mês 0-based)
  private readonly limiteDiasJornadaRetroativaBypass = 45;

  public get avisoLimiteJornadaRetroativa(): string {
    if (this.isBypassLimiteRetroativaAtivo()) {
      return '⚠️ Atenção: até 15/08/2026 o registro retroativo está liberado para os últimos 45 dias (bypass #162968).';
    }
    return '⚠️ Atenção: o registro de jornadas retroativas é permitido apenas para os últimos 15 dias corridos.';
  }

  public get mensagemErroLimiteJornadaRetroativa(): string {
    if (this.isBypassLimiteRetroativaAtivo()) {
      return 'Data inválida. Só é permitido registrar jornadas dos últimos 45 dias (bypass até 15/08/2026).';
    }
    return 'Data inválida. Só é permitido registrar jornadas dos últimos 15 dias.';
  }

  private isBypassLimiteRetroativaAtivo(): boolean {
    const hoje = this.getHojeSemHorario();
    const fim = new Date(this.dataFimBypassLimiteRetroativa);
    fim.setHours(23, 59, 59, 999);
    return hoje.getTime() <= fim.getTime();
  }

  private getLimiteDiasJornadaRetroativaVigente(): number {
    return this.isBypassLimiteRetroativaAtivo()
      ? this.limiteDiasJornadaRetroativaBypass
      : this.limiteDiasJornadaRetroativa;
  }
  //Injeções
  authService = inject(AuthService);
  ConvivaErrors = inject(ConvivaErrorHandlingService);
  filtroService = inject(FiltroService);
  spinnerService = inject(NgxSpinnerService);
  psicologoService = inject(PsicologoService);
  toastr = inject(ToastrService);
  escolaService = inject(EscolaService);
  router = inject(Router);
  relogioPontoService = inject(RelogioPontoService);
  mapsService = inject(MapsService);
  utilsService = inject(UtilsService);
  //Variaveis de Login
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;

  // Breadcrumb
  public breadcrumb: PageBreadcrumb[] = [
    { route: '/home', name: 'Home' },
    { route: '/painel-atividade-psicologo', name: 'Painel de Atividade do Psicólogo ' }
  ];

  constructor() {
    this.userLogado = this.authService.getUser();

    if (this.userLogado != null && !this.userLogado.flPsicologo) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }

    if (this.userLogado && (this.userLogado.psicologosInativos === undefined || this.userLogado.psicologosInativos === null)) {
      this.userLogado.psicologosInativos = false;
    }

    this.atividadeDiretoria = this.userLogado?.apenasDiretoria || false;
  }

  public cpfPsicologoSelecionado: string = '';
  public showModalJustificativaTempoRegistroAtividade: boolean = false;
  public showModalJustificativaDistancia: boolean = false;
  public showModalJustificativaCheckinOutPsicologo: boolean = false;
  public showModalAdicionarJornada: boolean = false;
  public showModalJornadaAtividades: boolean = false;
  public showModalAprovacao: boolean = false;
  public showModalExcluirAtividade: boolean = false;
  public showModalExcluirJornada: boolean = false;
  public qtdeCaracteresDescricao: number = 0;
  public qtdeCaracteresDescricaoOut: number = 0;
  public lstPsicologos: Psicologo[] = [];
  public permiteInserirJornada: boolean = false;

  /** Retroativa: Psicólogo usa CPF do login; demais perfis dependem do combo. */
  public get podeAdicionarJornadaRetroativa(): boolean {
    const perfil = this.userLogado?.codigoPerfil;
    if (perfil == null || !this.perfisQuePodemInserirJornadasRetroativas.includes(perfil)) {
      return false;
    }
    if (perfil === Perfil.Psicólogo) {
      return !!this.userLogado?.cpf;
    }
    return this.permiteInserirJornada;
  }

  public jornadaNaoFinalizada?: JornadaPsicologo;
  private jornadaAtivaPsicologo?: JornadaPsicologo;
  /** #155893 — Código da jornada retornada por GetJornadaEmAberto (mesma fonte do ícone verde). */
  private codigoJornadaEmAberto: number | null = null;
  /** #155893 — Força redraw da coluna Ações após carregar jornada ativa com filtro de Escola. */
  public gridAcoesRefreshKey = 0;
  public totalHorasAtividades?: Date;
  public codigoJornadaAnteriorInserida: number = 0;
  public codigoJornadaAtividadeExcluir: number = 0;
  public jornadaIdParaExcluir: number = 0;
  public itemJornadaExcluir: JornadaPsicologo;
  public atividadeDiretoria: boolean = false;

  public submitted: boolean = false;
  public parametroCdDiretoria: any;
  public parametroCdEscola: any;
  public diretoriasModal: Diretoria[] = [];
  public escolasModal: Escola[] = [];
  /** #179571 — busca acento-insensitive (Profª/PROFA, Stéfano/STEFANO). */
  public readonly searchUreModalFn = ngSelectSearchFnPorLabel(
    (item: Diretoria) => item?.nomeDiretoria
  );
  public readonly searchEscolaModalFn = ngSelectSearchFnPorLabel(
    (item: Escola) => item?.nomeEscola ?? item?.codigoEscola
  );
  public ultimaJornadaRegistrada: JornadaPsicologo | null;
  public lstPainelAtividadePsicologos: JornadaPsicologo[] = [];
  public lstAtividades: JornadaPsicologoAtividade[] = [];
  public itemJustificativaCheckinOutPsicologo: JornadaPsicologo;
  public itemJustificativaTempoRegistroAtividade: JornadaPsicologo;
  public itemJustificativaDistancia: JornadaPsicologo;
  public jornadaConsulta: JornadaPsicologo;
  public diretorias: Diretoria[] = [];
  public escolas: Escola[] = [];
  public filtros: FiltroPadrao;
  public showModalDeslocamento:boolean = false;
  public showSectionDeslocamento:boolean = false;
  public showBotonDeslocamento:boolean = false;
  public gerouRota: boolean = false;
  public subTable: boolean = false;

  public get restringeDataRetroativaJornada(): boolean {
    return this.userLogado?.codigoPerfil === Perfil.Psicólogo
      || this.userLogado?.codigoPerfil === Perfil.CoordenadorPsicologo;
  }

  public get dataMinimaCheckInJornada(): string | null {
    const dataMinima = this.getDataMinimaJornadaRetroativa();
    return dataMinima ? this.formatLocalISO(dataMinima) : null;
  }

  public get dataMaximaCheckInJornada(): string {
    const fimDoDia = this.getHojeSemHorario();
    fimDoDia.setHours(23, 59, 0, 0);
    return this.formatLocalISO(fimDoDia);
  }

  //Variaveis de Deslocamento
  public polosOrigem: Polo[] = [];
  public diretoriasOrigem: Diretoria[] = [];
  public escolasOrigem: Escola[] = [];
  // Variaveis de Mapa
  public requestRoute: google.maps.DirectionsRequest  = <google.maps.DirectionsRequest>{};
  public resultRoute: google.maps.DirectionsResult = <google.maps.DirectionsResult>{};
  public totalKm: number = 0;
  public totalSeg: number = 0;
  public totalDuration: string;
  public horaChegada: string;
  public lstTipoTransporte = [{id: 1, name:"Bicicleta" }, {id: 2, name:"Carro" }, {id: 3, name:"Transporte público" }, {id: 4, name:"A Pé" }, {id: 5, name:"Motocicleta" }];
  public latOrigem: number  = 0;
  public lngOrigem: number = 0;
  public latDestino: number = 0;
  public lngDestino: number = 0;
  // Variaveis de Deslocamento Escola/Diretoria
  public escolaOrigem: Escola = new Escola();
  public escolaDestino: Escola = new Escola();
  public diretoriaOrigem: Diretoria = new Diretoria();
  public diretoriaDestino: Diretoria = new Diretoria();
  public titleOrigem: string = '';
  public titleOrigemMark: string = '';
  public titleDestino: string = '';
  public titleDestinoMark: string = '';
  public atividadeDiretoriaOrigem: boolean = false;
  public atividadeDiretoriaDestino: boolean = false;
  public msgLatLongInvalida: string = '';
  public model: AtividadePsicologoDeslocamento = new AtividadePsicologoDeslocamento();

  //#region Formulários
  public formPesquisar!: FormGroup;
  public formJustificativaTempoRegistroAtividade!: FormGroup;
  public formJustificativaDistancia!: FormGroup;
  public formJustificativaCheckinOut!: FormGroup;
  public formAdicionarJornada!: FormGroup;
  public get form() { return this.formPesquisar.controls; }
  public get formTempo() { return this.formJustificativaTempoRegistroAtividade.controls; }
  public get formDistancia() { return this.formJustificativaDistancia.controls; }
  public get formCheckinOut() { return this.formJustificativaCheckinOut.controls; }
  public get formJornada() { return this.formAdicionarJornada.controls; }
  //#endregion

  //#region Colunas da tabela

  private getDetalhesComResumo(pai: JornadaPsicologo): any[] {
    const detalhes = pai.atividades.map(a => ({ ...a, isSummary: false }));
    if (detalhes.length) {
      const resumo = { ...detalhes[0], isSummary: true };
      detalhes.push(resumo);
    } else {
      detalhes.push({ isSummary: true } as any);
    }
    return detalhes;
  }

  public rowFormatter(row: any) {
    const data = row.getData() as JornadaPsicologo;
    if (data.justificativaJornadaAnterior?.length) {
      const el = row.getElement();
      // el.style.backgroundColor = '#e3e39a';
      el.classList.add('row-nao-validado');
    }
    // row.reformat();
  }

  public colunasGrid = [

    {
      title: '',
      field: 'iconeSubGrid',
      width: 40,
      hozAlign: 'center',
      headerSort: false,
      frozen: true,
      print: false,
      download: false,
      formatter: () => '<i class="fa fa-plus"></i>',
      initialSort: [
        { column: 'iconeAprovacao', dir: 'asc' }
      ],
      cellClick: (e: MouseEvent, cell: any) => {
        const row = cell.getRow();
        const rowElem = row.getElement();
        const jornada = row.getData() as JornadaPsicologo;
        const holder = rowElem.querySelector('.sub-holder');

        if (holder) {
          (row as any)._sub.destroy();
          holder.remove();
          cell.getElement().innerHTML = '<i class="fa fa-plus"></i>';
          (row as any)._sub = null;
          return;
        }

        const wrap = document.createElement('div');
        wrap.className = 'sub-holder';
        wrap.style.width = '100%';
        wrap.style.boxSizing = 'border-box';
        wrap.style.padding = '8px 48px';

        rowElem.appendChild(wrap);
        const dadosFilho = this.getDetalhesComResumo(jornada);
        const sub = new Tabulator(wrap, {
          data: dadosFilho,
          height: 240,
          columns: this.subGridCols(this, jornada),
          layout: 'fitDataStretch',
          reactiveData: true,
          placeholder: 'Sem Atividades registradas',
          renderHorizontal: 'virtual',
          locale: true,
          langs: {
            'pt-br': {
              data: { loading: 'Carregando', error: 'Erro' },
              groups: { item: 'item', items: 'itens' },
              pagination: {
                page_size: 'Tamanho da Página',
                page_title: 'Mostrar Pagina',
                first: 'Primeiro',
                first_title: 'Primeira Página',
                last: 'Último',
                last_title: 'Última Pagina',
                prev: 'Anterior',
                prev_title: 'Pagina Anterior',
                next: 'Próximo',
                next_title: 'Próxima Pagina',
                all: 'Tudo',
                counter: { showing: 'Visualizando', of: 'de', rows: 'linhas', pages: 'paginas' }
              }
            }
          }
        });

        (row as any)._sub = sub;
        cell.getElement().innerHTML = '<i class="fa fa-minus"></i>';
      }
    },
    {
      title: 'Data da visita à URE/Escola',
      field: 'dataVisitaStr',
      width: 220,
      hozAlign: 'center',
      headerHozAlign: 'center',
      headerFilter: 'input',
      formatter: (cell : any) => {
        const data = cell.getRow().getData();
        return formatDate(data.dataInicio, 'dd/MM/yyyy', 'pt-BR');
      },

      exportValue: (row: JornadaPsicologo) =>
        formatDate(row.dataInicio, 'dd/MM/yyyy', 'pt-BR'),

      accessorDownload: (value: any, data: JornadaPsicologo) =>
        formatDate(data.dataInicio, 'dd/MM/yyyy', 'pt-BR'),

      accessorPrint: (value: any, data: JornadaPsicologo) =>
        formatDate(data.dataInicio, 'dd/MM/yyyy', 'pt-BR'),

      exportType: 'date',
      exportFormat: 'dd/MM/yyyy',
    },

    {
      title: 'Aprovação',
      field: 'iconeAprovacao',
      width: 120,
      hozAlign: 'center',
      headerHozAlign: 'center',
      headerFilter: 'list',
      headerFilterParams: {
        values: {
          "": "Todos",
          "nao-registrado": "Não Registrado",
          "nao-validado": "Não Validado",
          "validado": "Validado"
        },
        listItemFormatter: (value: string, text: string) => {
          let iconClass = '';
          if (value === 'nao-registrado') {
            iconClass = 'fa-solid fa-circle-dot';
          } else if (value === 'nao-validado') {
            iconClass = 'circulo-laranja fa-solid fa-circle';
          } else if (value === 'validado') {
            iconClass = 'circulo-verde fa-solid fa-circle';
          }
          return iconClass ? `<i class="${iconClass}"></i> ${text}` : text;
        }
      },
      headerFilterFunc: (headerValue: string, _rowValue: any, rowData: JornadaPsicologo) => {
        if (!headerValue) return true; // Show all when no filter selected

        const status = this.getAprovacaoLegenda(rowData);

        if (headerValue === 'nao-registrado' && status === 'Não Registrado') return true;
        if (headerValue === 'nao-validado' && status === 'Não Validado') return true;
        if (headerValue === 'validado' && status === 'Validado') return true;

        return false;
      },
      sorter: (a: any, b: any, aRow: any, bRow: any) => {
        const sortA = this.getAprovacaoOrder(aRow.getData() as JornadaPsicologo);
        const sortB = this.getAprovacaoOrder(bRow.getData() as JornadaPsicologo);
        return sortA - sortB;

      },
      formatter: (cell: any) => {
        return `<i class="${this.getAprovacaoIcon(cell.getData() as JornadaPsicologo)}"></i>`;
      },
      exportValue: (row: JornadaPsicologo) => this.getAprovacaoLegenda(row),
      accessorDownload: (_value: any, data: JornadaPsicologo) => this.getAprovacaoLegenda(data),
      accessorPrint: (_value: any, data: JornadaPsicologo) => this.getAprovacaoLegenda(data),
    },
    {
      title: 'Ações',
      field: 'acoes',
      width: 250,
      hozAlign: 'center',
      headerHozAlign: 'center',
      print: false,
      download: false,
      formatter: (cell: any) => {
        const r = cell.getData() as JornadaPsicologo;
        const html: string[] = [];
        html.push(`<a href="javascript:void(0)" data-act="view"><i class="fa fa-eye"></i></a>`);
        // if (this.temJustificativaTempoRegistroAtividade(r.statusTempoRegistro || 0)) html.push(`<a href="javascript:void(0)" data-act="just-tempo"><i class="icon-justificativa-tempo-registro"></i></a>`);
        if (this.temJustificativaHorarioPsicologo()) html.push(`<a href="javascript:void(0)" data-act="just-horario"><i class="fa fa-clock"></i></a>`);
        if (this.podeExibirJustificativa(r)) html.push(`<a href="javascript:void(0)" data-act="just-fiscal"><i class="fa fa-clock"></i></a>`);
        if (this.temJustificativaDistancia(this.getDistanciaNumerica(r.distanciaEscolaInicio), this.getDistanciaNumerica(r.distanciaEscolaFim)) && r.justificativaDistancia) html.push(`<a href="javascript:void(0)" data-act="just-dist"><i class="fa fa-comment"></i></a>`);
        if (this.temPermissaoAprovacao()) html.push(`<a href="javascript:void(0)" data-act="aprov"><i class="fa-regular fa-square-check"></i></a>`);
        // #155893 — Ícones sempre visíveis (permissão); check-in validado só ao clicar em "+".
        if (this.exibirBotaoInserirAtividade(r)) {
          html.push(`<a href="javascript:void(0)" data-act="add-ativ"><i class="fa-solid fa-circle-plus"></i></a>`);
        }
        if (this.exibirBotaoExcluirJornada()) {
          html.push(`<a href="javascript:void(0)" data-act="del" title="Excluir jornada"><i class="fa-regular fa-trash-can"></i></a>`);
        }
        return `<div class="icones-acoes">${html.join('')}</div>`;
      },
      cellClick: (e: MouseEvent, cell: any) => {
        const act = (e.target as HTMLElement).closest('a')?.getAttribute('data-act');
        const row = cell.getData() as JornadaPsicologo;
        switch (act) {
          case 'view': this.AbrirVisualizar(row); break;
          // case 'just-tempo': this.AbrirJustificativaTempoRegistroAtividade(row); break;
          case 'just-horario': this.AbrirJustificativaCheckinOutPsicologo(row); break;
          case 'just-fiscal': this.AbrirJustificativaCheckinOutFiscal(row); break;
          case 'just-dist': this.AbrirJustificativaDistancia(row); break;
          case 'aprov': this.AbrirAprovacao(row); break;
          case 'add-ativ': this.redirectToAddAtividade(row.codigoJornada, row); break;
          case 'del':
            this.jornadaIdParaExcluir = row.codigoJornada; // guarda o id da linha
            this.ModalExcluirJornada();
            break;
        }
      }
    },
    { title: 'Cd Jornada', field: 'codigoJornada', width: 150, hozAlign: 'center', headerHozAlign: 'center', headerFilter: 'input' },
    { title: 'Psicologo', field: 'nomePsicologo', width: 200, hozAlign: 'center', headerHozAlign: 'center', headerFilter: 'input' },
    {
      title: 'CPF',
      field: 'codigoCPF',
      width: 150,
      hozAlign: 'center',
      headerHozAlign: 'center',
      headerFilter: 'input',
      formatter: (cell: any) => (cell.getData() as JornadaPsicologo).codigoCPF?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') ?? ''
    },
    {
      title: 'Polo / Diretoria',
      field: 'poloDiretoria',
      width: 150,
      hozAlign: 'center',
      headerHozAlign: 'center',
      headerFilter: 'input',
      formatter: (cell: any) => {
        const j = cell.getData() as JornadaPsicologo;
        return `${j.codigoPolo} - ${j.nomeDiretoria}`;
      }
    },
    { title: 'Escola', field: 'nomeEscola', width: 250, hozAlign: 'center', headerHozAlign: 'center', headerFilter: 'input' },
    { title: 'Jornada Retroativa', field: 'justificativaJornadaAnterior', width: 180, hozAlign: 'center', headerHozAlign: 'center', print: false, download: false },

    {
      title: 'Check-in/out',
      field: 'checkInOutStr',
      width: 180,
      hozAlign: 'center',
      headerHozAlign: 'center',
      headerFilter: 'input',
      formatter: (cell: any) => {
        const r = cell.getData() as JornadaPsicologo;
        const texto = this.formatCheckInOutLinha(r);
        cell.getElement().classList.toggle('alert-distancia', !possuiCheckoutEfetivo(r));
        return texto;
      },
      exportValue: (row: JornadaPsicologo) =>
        this.formatCheckInOutLinha(row),

      accessorDownload: (value: any, data: JornadaPsicologo) =>
        this.formatCheckInOutLinha(data),

      accessorPrint: (value: any, data: JornadaPsicologo) =>
        this.formatCheckInOutLinha(data),

      exportType: 'string',
    },

    {
      title: 'Hrs Trabalhadas',
      field: 'horasTrabalhadasStr',
      width: 150,
      hozAlign: 'center',
      headerHozAlign: 'center',
      headerFilter: 'input',
      formatter: (cell: any) => {
        const r = cell.getData() as JornadaPsicologo;
        const texto = `${r.horasTrabalhadasStr} h`;
        const classe = this.getStatusClassHT(r.statusHorasTrabalhadas ?? 0);
        if (classe) cell.getElement().classList.add(classe);
        return texto;
      },
      exportType: 'time',
      exportFormat: 'HH:mm'
    },
    {
      title: 'Tempo Reg.Ativ.',
      field: 'tempoRegistroStr',
      width: 150,
      hozAlign: 'center',
      headerHozAlign: 'center',
      headerFilter: 'input',
      formatter: (cell: any) => {
        const r = cell.getData() as JornadaPsicologo;
        const classe = this.getStatusClass(r.statusTempoRegistro || 0);
        if (classe) cell.getElement().classList.add(classe);
        return r.tempoRegistroStr;
      },
      exportType: 'time',
      exportFormat: 'HH:mm'
    },
    {
      title: 'Distância Início',
      field: 'distanciaEscolaInicio',
      width: 150,
      hozAlign: 'center',
      headerHozAlign: 'center',
      headerFilter: 'input',
      formatter: (cell: any) => {
        const v = cell.getValue();
        const num = this.getDistanciaNumerica(v);
        const alerta = num >= 2000;
        cell.getElement().classList.toggle('alert-distancia', alerta);
        return `${alerta ? '<i class="fa-solid fa-triangle-exclamation"></i> ' : ''}${v ?? 'N/A'}`;
      }
    },
    {
      title: 'Distância Fim',
      field: 'distanciaEscolaFim',
      width: 150,
      hozAlign: 'center',
      headerHozAlign: 'center',
      headerFilter: 'input',
      formatter: (cell: any) => {
        const v = cell.getValue();
        const num = this.getDistanciaNumerica(v);
        const alerta = num >= 2000;
        cell.getElement().classList.toggle('alert-distancia', alerta);
        return `${alerta ? '<i class="fa-solid fa-triangle-exclamation"></i> ' : ''}${v ?? 'N/A'}`;
      }
    }

  ];

  public subGridCols(ctx: any, pai: JornadaPsicologo): any[] {
    return [
      {
        title: 'Cd Atividade',
        field: 'codigoAtividade',
        width: 80,
        hozAlign: 'center',
        formatter: (cell: any) => cell.getRow().getData().isSummary ? 'Tempo de Registro' : cell.getValue()
      },
      // {
      //   title: 'Data da visita à URE/Escola',
      //   field: 'dataAtividade',
      //   width: 220,
      //   hozAlign: 'center',
      //   formatter: (cell: any) => {
      //     const row = cell.getRow().getData();
      //     return row.isSummary ? '' : (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('pt-BR') : '');
      //   }
      // },
      {
        title: 'Data Registro',
        field: 'dataOperacao',
        width: 150,
        hozAlign: 'center',
        formatter: (cell: any) => {
          const row = cell.getRow().getData();
          return row.isSummary ? '' : (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('pt-BR') : '');
        }
      },
      {
        title: 'Título da Atividade',
        field: 'titulo',
        width: 450,
        formatter: (cell: any) => cell.getRow().getData().isSummary ? 'Tempo total de registro das atividades listadas acima (mm:ss)' : (cell.getValue() || 'N/A')
      },
      {
        title: 'Aprovado',
        field: 'statusAprovacaoStr',
        width: 110,
        formatter: (cell: any) => cell.getRow().getData().isSummary ? '' : (cell.getValue() || 'N/A')
      },
      {
        title: 'Tipo de Atividade',
        field: 'tipoAtividadeStr',
        width: 150,
        formatter: (cell: any) => cell.getRow().getData().isSummary ? '' : (cell.getValue() || 'N/A')
      },
      {
        title: 'Qtd horas',
        field: 'qtdHoras',
        width: 100,
        hozAlign: 'center',
        formatter: (cell: any) => {
          const row = cell.getRow().getData() as any;
          if (row.isSummary) return pai.tempoRegistroTotal;
          if (!row.tempoAtividade) return 'N/A';
          return this.fmtHora(this.calculaTotalHorasTempoRegistro(+row.tempoAtividade)) || 'N/A';
        }
      },
      {
        title: 'Ações',
        field: 'acoes',
        width: 200,
        minWidth: 200,
        maxWidth: 200,
        formatter: (cell: any) => {
          const row = cell.getRow().getData() as any;
          if (row.isSummary) return '';
          const d = row as JornadaPsicologoAtividade;
          const html: string[] = [];
          html.push(`<a href="javascript:void(0)" data-act="view"><i class="fa fa-eye"></i></a>`);
          if (ctx.temPermissaoAprovacao()) html.push(`<a href="javascript:void(0)" data-act="aprov"><i class="fa-regular fa-square-check"></i></a>`);
          if ((ctx.temPermissaoEditarAtividade() && (d.statusAprovacao === 0 || d.statusAprovacao === 1))) html.push(`<a href="javascript:void(0)" data-act="edit"><i class="fa-solid fa-edit"></i></a>`);
          if ((ctx.temPermissaoExcluirAtividade() && (d.statusAprovacao === 0 || d.statusAprovacao === 1))) html.push(`<a href="javascript:void(0)" data-act="del"><i class="fa-solid fa-trash"></i></a>`);
          return `<div class="icones-acoes">${html.join('&nbsp;')}</div>`;
        },
        cellClick: (e: MouseEvent, cell: any) => {
          const d = cell.getData() as JornadaPsicologoAtividade;
          const act = (e.target as HTMLElement).closest('a')?.dataset['act'];
          switch (act) {
            case 'view': ctx.AbrirVisualizarDetalhe(pai.codigoJornada, d.codigoAtividade); break;
            case 'aprov': ctx.AbrirAprovacaoDetalhe(pai.codigoJornada, d.codigoAtividade); break;
            case 'edit': ctx.AbrirEditarAtividade(pai.codigoJornada, d.codigoAtividade); break;
            case 'del': ctx.AbrirExcluirAtividade(pai.codigoJornada, d.codigoAtividade, pai); break;
          }
        }
      }
    ];
  }

  public colunasNaoExportaveis: string[] = ['acoes', 'iconeSubGrid'];

  //#endregion

  public async ngOnInit() {
    this.formPesquisar = new FormGroup({
      nomePsicologo: new FormControl(null),
      codigoCPF: new FormControl(null),
      codigoPolo: new FormControl(null, Validators.required),
      codigoDiretoria: new FormControl(null, Validators.required),
      codigoEscola: new FormControl(null, Validators.required),
      dataInicio: new FormControl(null, Validators.required),
      dataFim: new FormControl(null, Validators.required)
    });

    this.formJustificativaTempoRegistroAtividade = new FormGroup({
      justificativaTempoRegistroAtividade: new FormControl(null, Validators.required)
    });

    this.formJustificativaDistancia = new FormGroup({
      JustificativaDistancia: new FormControl(null, Validators.required)
    });

    this.formJustificativaCheckinOut = new FormGroup({
      JustificativaCheckin: new FormControl(null, Validators.required),
      JustificativaCheckout: new FormControl(null, Validators.required),
      tipoRegistro: new FormControl(null, Validators.required),
      timeCheckinOutEntrada: new FormControl(null, Validators.required),
      timeCheckinOutSaida: new FormControl(null, Validators.required),
    });

    this.formAdicionarJornada = new FormGroup({
      dataCheckIn: new FormControl(null, [
        Validators.required,
        dataNaoFuturaValidator(),
        dataRetroativaLimiteValidator(
          () => this.getDataMinimaJornadaRetroativa(),
          this.mensagemErroLimiteJornadaRetroativa
        )
      ]),
      dataCheckOut: new FormControl(null, Validators.required),
      codigoDiretoriaModal: new FormControl(null, Validators.required),
      codigoEscolaModal: new FormControl(null, Validators.required),
      JustificativaSolicitacao: new FormControl(null, Validators.required),
      codigoPoloOrigem: new FormControl(null),
      codigoDiretoriaOrigem: new FormControl(null),
      codigoEscolaOrigem: new FormControl(null),
      horarioSaida: new FormControl(null),
      codigoTipoTransporte: new FormControl(null),
      horarioChegada: new FormControl({value: null, disabled: true}, this.gerouRota ? [Validators.required] : null),
      tempoDeslocamento: new FormControl({value: null, disabled: true}, this.gerouRota ? [Validators.required] : null),
      kmPercorrido: new FormControl({value: null, disabled: true}, this.gerouRota ? [Validators.required] : null),
    });

    this.userLogado!.psicologosInativos = false;
    this.authService.setUser(this.userLogado!);

    // Prefill URE, Escola, and Polo if present in login
    if (this.userLogado) {
      if (this.userLogado.codigoDiretoria) {
        this.formPesquisar.get('codigoDiretoria')?.setValue(this.userLogado.codigoDiretoria);
        this.formPesquisar.get('codigoDiretoria')?.disable();
      }
      if (this.userLogado.codigoEscola) {
        this.formPesquisar.get('codigoEscola')?.setValue(this.userLogado.codigoEscola);
        this.formPesquisar.get('codigoEscola')?.disable();
      }
      // Buscar polos pela URE (diretoria) do login e preencher o campo polo
      if (this.userLogado.codigoDiretoria) {
        const response = await lastValueFrom(this.psicologoService.getPolos(this.userLogado.codigoDiretoria)).catch((err) => { console.error('Erro ao buscar polos:', err); return null; });
        if (response && response.isSucess && Array.isArray(response.data) && response.data.length > 0) {
          let codigoPoloToSet = null;
          if (this.userLogado.codigoPolo) {
            // Procura o polo do usuário logado na lista
            const found = response.data.find((p: any) => Number(p.codigoPolo) === Number(this.userLogado?.codigoPolo));
            if (found) {
              codigoPoloToSet = Number(found.codigoPolo);
            }
          }
          // Se não achou, usa o primeiro da lista
          if (codigoPoloToSet === null) {
            codigoPoloToSet = Number(response.data[0].codigoPolo);
          }
          this.formPesquisar.get('codigoPolo')?.setValue(codigoPoloToSet);
          this.formPesquisar.get('codigoPolo')?.disable();
        } else {
          console.warn('Nenhum polo retornado ou resposta inválida:', response);
        }
      }
    }

    await this.getPsicologosPolo(1);
    await this.getDatas();
    // #155893 — Pré-carrega jornada em aberto ao iniciar (alinhado ao ícone verde do relógio de ponto).
    await this.carregarJornadaAtivaPsicologo();
    this.relogioPontoService.modalIniciarJornada$.subscribe(async (modalAberto) => {
      if (!modalAberto) {
        await this.sincronizarJornadaAtivaAposCheckin();
      }
    });
  }

  public async getPsicologosPolo(origemPolo: number) { // Origem Polo 1 = Login do usuário, Origem Polo 2 = Filtro de pesquisa
    this.spinnerService.show();

    const _filtroCpf = sessionStorage.getItem('painelPsicologo_filtroCpf');

    const polo = origemPolo == 1 ? this.userLogado?.codigoPolo : this.formPesquisar.get('codigoPolo')!.value;

    const response = await lastValueFrom(this.psicologoService.getPsicologosPorPolo(polo))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.hide();

    this.lstPsicologos = response.data;

    for (const item of this.lstPsicologos) {
      item.nomePsicologoCompleto = `${item.codigoCPF} - ${item.nomePsicologo}`;
    }


    if (this.userLogado?.codigoPerfil == Perfil.Psicólogo) {
      await this.preencherPsicologo();
    }
    else {
      const cpfRestaurado = this.userLogado?.filtroCpf ?? (_filtroCpf != "null" && _filtroCpf ? _filtroCpf : null);
      const psicologoRestaurado = cpfRestaurado
        ? this.lstPsicologos.find(p => cpfsIguais(p.codigoCPF, cpfRestaurado))
        : undefined;

      if (psicologoRestaurado) {
        this.formPesquisar.get('codigoCPF')?.setValue(psicologoRestaurado.codigoCPF);
        this.permiteInserirJornada = true;
        this.popularPsicologo();
      }
    }
  }

  public async preencherPsicologo() {
    const psicologoLogado = this.lstPsicologos.find(p => cpfsIguais(p.codigoCPF, this.userLogado?.cpf));

    if (!psicologoLogado) {
      // Mesmo sem retorno na lista do polo, psicólogo logado pode lançar retroativa.
      if (this.userLogado?.cpf) {
        this.cpfPsicologoSelecionado = this.userLogado.cpf;
        this.permiteInserirJornada = true;
        this.formPesquisar.get('codigoCPF')?.setValue(this.userLogado.cpf, { emitEvent: false });
      } else {
        this.permiteInserirJornada = false;
      }
      return;
    }

    this.lstPsicologos = [psicologoLogado];
    this.formPesquisar.get('codigoCPF')?.setValue(psicologoLogado.codigoCPF);
    this.formPesquisar.get('psicologoSelect')?.setValue(psicologoLogado.codigoCPF);
    this.permiteInserirJornada = true;
    this.cpfPsicologoSelecionado = String(psicologoLogado.codigoCPF);
    this.popularPsicologo();
  }

  public async onPoloChange(codigoPolo: number) {
    this.formPesquisar.get('codigoPolo')?.setValue(codigoPolo);
    this.formPesquisar.get('psicologoSelect')?.setValue(null);
    this.formPesquisar.get('codigoCPF')?.setValue(null);
    this.cpfPsicologoSelecionado = '';

    if (this.userLogado) {
      this.userLogado.codigoPolo = codigoPolo ?? 0;
      this.authService.setUser(this.userLogado);
    }

    await this.getPsicologosPolo(2);
  }

  observacaoFormatter(cell: any) {
    const value = cell.getValue();
    return value ? value : 'sem observação'; // Retorna "sem observação" se o valor for null ou vazio
  }

  getStatusClass(statusTempoRegistro: number): string {
    let resultado = 'circulo-verde';
    if (statusTempoRegistro == 1)
      resultado = 'circulo-amarelo';
    if (statusTempoRegistro == 2)
      resultado = 'circulo-vermelho';
    return resultado;
  }

  getStatusClassHT(statusHorasTrabalhadas: number): string {
    let resultado = 'circulo-branco';
    if (statusHorasTrabalhadas == 1)
      resultado = 'circulo-vermelho';
    return resultado;
  }

  getAprovacaoIcon(jornada: JornadaPsicologo): string {
    if (jornada.atividades == undefined || jornada.atividades == null || jornada.atividades?.length == 0) {
      return 'fa-solid fa-circle-dot';
    }

    if (jornada.atividades.length > 0) {
      const countAtividades = jornada.atividades.filter(r => r.statusAprovacao! > 1).length;
      if (countAtividades == 0) {
        return 'circulo-laranja fa-solid fa-circle';
      }

      if (countAtividades == jornada.atividades.length) {
        return 'circulo-verde fa-solid fa-circle';
      }
    }

    return 'circulo-laranja fa-solid fa-circle';
  }

  getAprovacaoOrder(jornada: JornadaPsicologo): number {
    if (!jornada.atividades || jornada.atividades.length === 0) {
      return 2;
    }

    const countAtividades = jornada.atividades.filter(r => r.statusAprovacao! > 1).length;

    if (countAtividades === 0) {
      return 1;
    }

    if (countAtividades === jornada.atividades.length) {
      return 3;
    }

    return 1;
  }

  getAprovacaoLegenda(jornada: JornadaPsicologo): string {
    if (!jornada || jornada.atividades == undefined || jornada.atividades == null || jornada.atividades?.length == 0) {
      return 'Não Registrado';
    }
    if (jornada.atividades.length > 0) {
      const countAtividades = jornada.atividades.filter(r => r.statusAprovacao! > 1).length;
      if (countAtividades == 0) {
        return 'Não Validado';
      }

      if (countAtividades == jornada.atividades.length) {
        return 'Validado';
      }
    }
    return 'Não Validado'

  }

  // Método helper para verificar si el usuario puede realizar acciones
  private canUserPerformAction(): boolean {
    if (!this.userLogado) {
      return false;
    }
    if (this.userLogado.psicologosInativos === undefined || this.userLogado.psicologosInativos === null) {
      this.userLogado.psicologosInativos = false;
    }
    return this.userLogado.psicologosInativos === false;
  }

  temPermissaoAprovacao(): boolean {
    return this.perfisQuePodemAprovar.includes(this.userLogado?.codigoPerfil as Perfil) && this.canUserPerformAction();
  }

  temPermissaoAprovacaoDetalhe(): boolean {
    return this.perfisQuePodemAprovarDetalhe.includes(this.userLogado?.codigoPerfil as Perfil) && this.canUserPerformAction();
  }

  temJustificativaTempoRegistroAtividade(status: number): boolean {
    return status != 0 && this.perfisJustificativaTempoRegistroAtividade.includes(this.userLogado?.codigoPerfil as Perfil) && this.canUserPerformAction();
  }

  temJustificativaHorarioPsicologo(): boolean {
    return this.perfisJustificativaHorarioPsicologo.includes(this.userLogado?.codigoPerfil as Perfil) && this.canUserPerformAction();
  }

  temJustificativaHorarioPsicologoFiscal(): boolean {
    return this.perfisJustificativaHorarioPsicologoFiscal.includes(this.userLogado?.codigoPerfil as Perfil) && this.canUserPerformAction();
  }

  podeExibirJustificativa(item: JornadaPsicologo): boolean {
    return this.temJustificativaHorarioPsicologoFiscal() &&
      (
        (item.stAjusteAprovacaoEntrada != null && item.stAjusteAprovacaoEntrada < 1) ||
        (item.stAjusteAprovacaoSaida != null && item.stAjusteAprovacaoSaida < 1)
      )
  }

  temJustificativaDistancia(distanciaInicio: number, distanciaFim: number): boolean {
    return (distanciaInicio > 2000 || distanciaFim > 2000) && this.perfisJustificativaDistancia.includes(this.userLogado?.codigoPerfil as Perfil) && this.canUserPerformAction();
  }

  temPermissaoInserirAtividade(r?: JornadaPsicologo): boolean {
    const temPerfil = this.perfisInserirAtividade.includes(this.userLogado?.codigoPerfil as Perfil)
      && this.canUserPerformAction();

    if (!r) return temPerfil;

    return temPerfil && !jornadaEstaAprovada(r);
  }

  temPermissaoExcluirJornada(): boolean {
    return this.perfisExcluirJornada.includes(this.userLogado?.codigoPerfil as Perfil) && this.canUserPerformAction();
  }

  temPermissaoExcluirJornadaGestorConviva(): boolean {
    return this.perfilGestorConviva.includes(this.userLogado?.codigoPerfil as Perfil) && this.canUserPerformAction();
  }

  temPermissaoEditarAtividade(): boolean {
    return this.perfisEditarAtividade.includes(this.userLogado?.codigoPerfil as Perfil) && this.canUserPerformAction();
  }

  temPermissaoExcluirAtividade(): boolean {
    return this.perfisExcluirAtividade.includes(this.userLogado?.codigoPerfil as Perfil) && this.canUserPerformAction();
  }

  /** #155893 — Visibilidade do "+"; regra de check-in validada em redirectToAddAtividade. */
  exibirBotaoInserirAtividade(jornada?: JornadaPsicologo): boolean {
    return this.temPermissaoInserirAtividade(jornada);
  }

  /** #155893 — Lixeira sempre visível com permissão; exclusão sem validação de check-in. */
  exibirBotaoExcluirJornada(): boolean {
    return this.temPermissaoExcluirJornada() || this.temPermissaoExcluirJornadaGestorConviva();
  }


  iconesPsicologo(): boolean {
    return this.userLogado?.codigoPerfil == Perfil.Psicólogo;
  }

  iconesFiscal(): boolean {
    return this.userLogado?.codigoPerfil == Perfil.FiscalPsicologo || this.userLogado?.codigoPerfil == Perfil.GestorConviva;
  }

  public async AbrirEditarAtividade(codigoJornada: number, codigoJornadaAtividade: number) {
    this.router.navigate(['registro-saida', 'editar-registro-atividade'],
      { queryParams: { jornadaId: codigoJornada, atividadeId: codigoJornadaAtividade } });
  }

  public async AbrirExcluirAtividade(codigoJornada: number, codigoJornadaAtividade: number, item: JornadaPsicologo) {
    // this.router.navigate(['registro-saida', 'excluir-registro-atividade'],
    //   { queryParams: { jornadaId: codigoJornada, atividadeId: codigoJornadaAtividade } });
    // this.codigoJornadaExcluir = codigoJornada;
    this.codigoJornadaAtividadeExcluir = codigoJornadaAtividade;
    this.jornadaNaoFinalizada = item;
    this.showModalExcluirAtividade = true;
  }

  public async AbrirJustificativaCheckinOutPsicologo(item: JornadaPsicologo) {
    this.itemJustificativaCheckinOutPsicologo = item;
    this.showModalJustificativaCheckinOutPsicologo = true;
    this.qtdeCaracteresDescricao = 0;
    this.formJustificativaCheckinOut.reset();
  }

  public async AbrirAdicionarJornada() {
    await this.carregarJornadaAtivaPsicologo(this.lstPainelAtividadePsicologos);

    // #162979 — Bloqueio indevido: validar jornada do operador (mesmo CPF do relógio) quando a
    // consulta da listagem usou CPF do psicólogo filtrado (coordenador) ou a API veio null.
    if (this.perfilExigeJornadaAtivaParaInserirAtividade() && !this.podeInserirAtividadeNaJornada()) {
      const liberadoPorOperador = this.temPermissaoInserirAtividade()
        && await this.operadorPossuiJornadaEmAberto();
      if (!liberadoPorOperador) {
        this.exibirAlertaRestricaoInserirJornadaAntiga();
        return;
      }
    }

    await this.getDiretorias();
    this.atividadeDiretoria = false;
    this.gerouRota = false;
    this.showSectionDeslocamento = false;
    this.showBotonDeslocamento = false;
    this.showModalAdicionarJornada = true;
    this.submitted = false;
    this.formAdicionarJornada.reset();
    this.formAdicionarJornada.get('dataCheckIn')?.updateValueAndValidity();
    this.qtdeCaracteresDescricao = 0;
  }

  public AbrirJustificativaCheckinOutFiscal(item: JornadaPsicologo) {
    const id = item.codigoJornada;
    this.router.navigate(['/aprovacao-ajuste-ponto'], { queryParams: { id } });
  }

  public async CadastrarJustificativaCheckinOutPsicologo() {
    //validar los campos de la forma
    if (this.formCheckinOut.invalid) {
      this.toastr.error('Por favor, preencha todos os campos obrigatórios');
      return;
    }
    //validar si son nulos los campos de la forma
    if (this.formJustificativaCheckinOut.get('JustificativaCheckin')?.value == null) {
      this.toastr.error('A justificativa deve ter no mínimo 10 caracteres');
      return;
    }
    if (this.formJustificativaCheckinOut.get('tipoRegistro')?.value == null) {
      this.toastr.error('Seleciona o tipo de registro');
      return;
    }
    if (this.formJustificativaCheckinOut.get('timeCheckinOutEntrada')?.value == null) {
      this.toastr.error('Seleciona a hora do check-in');
      return;
    }
    if (this.formJustificativaCheckinOut.get('JustificativaCheckin')?.value.length < 10) {
      this.toastr.error('A justificativa deve ter no mínimo 10 caracteres');
      return;
    }
    if (this.formJustificativaCheckinOut.get('JustificativaCheckin')?.value.length > 500) {
      this.toastr.error('A justificativa deve ter no máximo 500 caracteres');
      return;
    }
    if (this.formJustificativaCheckinOut.get('tipoRegistro')?.value == 3) {
      if (this.formJustificativaCheckinOut.get('JustificativaCheckout')?.value == null) {
        this.toastr.error('A justificativa deve ter no mínimo 10 caracteres');
        return;
      }
      if (this.formJustificativaCheckinOut.get('timeCheckinOutSaida')?.value == null) {
        this.toastr.error('Seleciona a hora do check-out');
        return;
      }
      if (this.formJustificativaCheckinOut.get('JustificativaCheckout')?.value.length < 10) {
        this.toastr.error('A justificativa deve ter no mínimo 10 caracteres');
        return;
      }
      if (this.formJustificativaCheckinOut.get('JustificativaCheckout')?.value.length > 500) {
        this.toastr.error('A justificativa deve ter no máximo 500 caracteres');
        return;
      }
    }
    const parametros = await this.setParametrosJustificativaCheckinOut();
    const resultConsulta = await lastValueFrom(this.psicologoService.getJornadaPorId(parametros.codigoJornada));
    if (!resultConsulta.isSucess) {
      this.toastr.error(resultConsulta.message, resultConsulta.title);
      return;
    }
    this.toastr.success(resultConsulta.message, resultConsulta.title);
    this.jornadaConsulta = resultConsulta.data;
    if (parametros.tipoRegistro == 1 || parametros.tipoRegistro == 3) {
      if (this.jornadaConsulta.justificativaCheckin != null) {
        this.toastr.error('Já existe uma justificativa de entrada para esta jornada');
        return;
      }
    }
    if (parametros.tipoRegistro == 2 || parametros.tipoRegistro == 3) {
      if (this.jornadaConsulta.justificativaCheckout != null) {
        this.toastr.error('Já existe uma justificativa de saída para esta jornada');
        return;
      }
    }
    this.showModalJustificativaCheckinOutPsicologo = false;
    const result = await lastValueFrom(this.psicologoService.setInserirJustificativaCheckinout(parametros));
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      return;
    }
    this.toastr.success(result.data.mensagem, result.title);
    if (!result.isSucess) {
      this.toastr.error('Erro ao cadastrar a justificativa');
      return;
    }

  }

  public setParametrosJustificativaCheckinOut(): JornadaJustificativaEntradaSaida {
    const parametros = new JornadaJustificativaEntradaSaida();
    const tipoRegistro = this.formJustificativaCheckinOut.get('tipoRegistro')?.value;

    const dataInicio = tipoRegistro == 1 || tipoRegistro == 3 ? this.formJustificativaCheckinOut.get('timeCheckinOutEntrada')?.value : null;
    const dataFim = tipoRegistro == 2 ? this.formJustificativaCheckinOut.get('timeCheckinOutEntrada')?.value : tipoRegistro == 3 ? this.formJustificativaCheckinOut.get('timeCheckinOutSaida')?.value : null;

    let dataInicioDate: Date;
    let dataFimDate: Date;

    if (dataInicio != null) {
      const dataInicioJornada = new Date(this.itemJustificativaCheckinOutPsicologo.dataInicio);
      const horaInicio = dataInicio.split(':');
      //var fechaInicio = new Date(dataInicioJornada.getFullYear(), dataInicioJornada.getMonth(), dataInicioJornada.getDate(), horaInicio[0], horaInicio[1]);
      const fechaInicio = new Date(
        dataInicioJornada.getFullYear(),
        dataInicioJornada.getMonth(),
        dataInicioJornada.getDate(),
        parseInt(horaInicio[0]),
        parseInt(horaInicio[1])
      );
      fechaInicio.setMinutes(fechaInicio.getMinutes() - fechaInicio.getTimezoneOffset());
      dataInicioDate = fechaInicio;
      parametros.dataInicio = dataInicioDate;
    }

    if (dataFim != null) {
      const dataFimJornada = this.itemJustificativaCheckinOutPsicologo.dataFim ? new Date(this.itemJustificativaCheckinOutPsicologo.dataFim) : new Date(this.itemJustificativaCheckinOutPsicologo.dataInicio);
      const horaFim = dataFim.split(':');
      //var fechaFim = new Date(dataFimJornada.getFullYear(), dataFimJornada.getMonth(), dataFimJornada.getDate(), horaFim[0], horaFim[1]);
      const fechaFim = new Date(
        dataFimJornada.getFullYear(),
        dataFimJornada.getMonth(),
        dataFimJornada.getDate(),
        parseInt(horaFim[0]),
        parseInt(horaFim[1])
      );
      fechaFim.setMinutes(fechaFim.getMinutes() - fechaFim.getTimezoneOffset());
      dataFimDate = fechaFim;
      parametros.dataFim = dataFimDate;
    }
    parametros.codigoJornada = this.itemJustificativaCheckinOutPsicologo.codigoJornada;
    parametros.JustificativaCheckin = (tipoRegistro == 1 || tipoRegistro == 3) ? this.formJustificativaCheckinOut.get('JustificativaCheckin')?.value : undefined;
    parametros.JustificativaCheckout = tipoRegistro == 2 ? this.formJustificativaCheckinOut.get('JustificativaCheckin')?.value :
      tipoRegistro == 3 ? this.formJustificativaCheckinOut.get('JustificativaCheckout')?.value : undefined;
    parametros.tipoRegistro = tipoRegistro;
    parametros.codigoUsuario = this.userLogado?.codigoUsuario!;
    parametros.nomeUsuario = this.userLogado?.nome!;
    return parametros;
  }

  public validaJornadaAnterior(){
    if (this.formAdicionarJornada.invalid) {
      this.toastr.error('Por favor, preencha todos os campos obrigatórios');
      return false;
    }
    if (this.formAdicionarJornada.get('JustificativaSolicitacao')?.value.length < 10) {
      this.toastr.error('A justificativa deve ter no mínimo 10 caracteres');
      return false;
    }
    if (this.formAdicionarJornada.get('JustificativaSolicitacao')?.value.length > 500) {
      this.toastr.error('A justificativa deve ter no máximo 500 caracteres');
      return false;
    }
    return true;
  }

  public async RevisarJornada() {
    this.submitted = true;
    this.formAdicionarJornada.markAllAsTouched();

    if (!this.validaJornadaAnterior()) {
      return;
    }

    this.spinnerService.show();

    const parametros = this.SetParametrosJornada();

    // Busca ampla (sem escola/diretoria): mesma regra de anti-duplicidade no dia do psicólogo.
    const result = await lastValueFrom(this.psicologoService.getJornadas(this.filtros.codigoPolo ?? 0, undefined, undefined, parametros.cpf, parametros.dataInicio, parametros.dataInicio))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.data.mensagem, result.title);
      this.spinnerService.hide();
      return;
    }

    if (result.data.length > 0) {
      const fechaInicio = new Date(parametros.dataInicio);
      const fechaFin = new Date(parametros.dataFim);

      // #169031 — overlap com DataFim (backend), não horaFimMasTempoRegistro (UI de horas trabalhadas).
      const jornadaExistente = (result.data as JornadaPsicologo[]).find((j) =>
        jornadasSobrepoemHorario(j, fechaInicio, fechaFin)
      );

      if (jornadaExistente) {
        const inicio = jornadaExistente.horaInicio
          ?? new Date(jornadaExistente.dataInicio).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        const fimCheckout = possuiCheckoutEfetivo(jornadaExistente) && jornadaExistente.dataFim
          ? new Date(jornadaExistente.dataFim).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
          : (possuiCheckoutEfetivo(jornadaExistente) && jornadaExistente.hrAjusteSaida
            ? new Date(jornadaExistente.hrAjusteSaida).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
            : 'em andamento');
        const codigo = extrairCodigoJornada(jornadaExistente);
        const escolaTxt = (jornadaExistente.codigoEscola ?? 0) > 0
          ? `${jornadaExistente.codigoEscola} - ${jornadaExistente.nomeEscola}`
          : 'Atividade na URE (sem escola)';

        await this.exibirJornadaConflitanteNaListagem(jornadaExistente, parametros.cpf);

        this.toastr.error(
          `Já existe a jornada ${codigo ? '#' + codigo + ' ' : ''}em ${jornadaExistente.nomeDiretoria}, ${escolaTxt}, ` +
          `no horário de ${inicio} às ${fimCheckout}. Ela foi carregada na listagem — ajuste ou exclua antes de cadastrar outra no mesmo período.`
        );
        this.spinnerService.hide();
        // A busca ampla acima mesclou a jornada conflitante na grade. Não pesquisar
        // novamente com o filtro restrito de Diretoria/Escola, pois jornadas
        // históricas com CD_DIRETORIA = 0 (como a #267292) seriam removidas da tela.
        await this.closeModalAdicionarJornada(false);
        return;
      }
    }
    const diretoria = this.diretoriasModal.filter(d => d.codigoDiretoria == parametros.codigoDiretoria)?.[0];
    const escola = this.escolasModal.filter(e => e.codigoEscola == parametros.codigoEscola)?.[0];
    // #162968 — evita crash quando o nome não tem o padrão "CIE - Nome"
    const partesNomeEscola = escola?.nomeEscola?.split(' - ') ?? [];
    const nomeEscola = (partesNomeEscola.length > 1 ? partesNomeEscola.slice(1).join(' - ') : escola?.nomeEscola)?.trim() ?? '';

    const parametrosInsert: JornadaPsicologosInserir = {
      codigoDiretoria: parametros.codigoDiretoria,
      nomeDiretoria: diretoria?.nomeDiretoria ?? '',
      codigoEscola: parametros.codigoEscola,
      nomeEscola: nomeEscola ?? '',
      codigoPsicologo: Number(parametros.cpf),
      dataInicio: parametros.dataInicio,
      dataFim: parametros.dataFim,
      justificativa: parametros.JustificativaSolicitacao,
      deslocamento: parametros.Deslocamento ?? null
    };

    const resultInsert = await lastValueFrom(this.psicologoService.setInserirJornadaAnterior(parametrosInsert))
      .catch((err) => {
        console.error('Erro na requisição setInserirJornadaAnterior:', err);
        this.spinnerService.hide();

        if (err.status === 0) {
          this.toastr.error('Erro de CORS: Verifique se o backend está configurado para permitir requisições do frontend', 'Erro de Conexão');
        } else {
          this.toastr.error('Erro ao inserir jornada retroativa. Tente novamente.', 'Erro');
        }
        return null;
      });

    if (!resultInsert || !resultInsert.isSucess) {
      if (resultInsert) {
        this.toastr.error(resultInsert.message, resultInsert.title);
      }
      if (this.respostaIndicaJornadaDuplicada(resultInsert?.message)) {
        const exibiu = await this.exibirDuplicidadeRetornadaPeloBackend(parametros);
        this.spinnerService.hide();
        if (exibiu) {
          await this.closeModalAdicionarJornada(false);
        }
        return;
      }
      await this.OnPesquisar();
      this.spinnerService.hide();
      return;
    }

  this.toastr.success(resultInsert.message, resultInsert.title);
  this.codigoJornadaAnteriorInserida = resultInsert.data.codigoGrande;

  await this.closeModalAdicionarJornada();
  }

  private respostaIndicaJornadaDuplicada(message?: string | null): boolean {
    return !!message && message.includes('Cd Jornada');
  }

  /** #175520 — O backend bloqueou uma jornada que a pré-checagem não viu. Mescla o dia na grade. */
  private async exibirDuplicidadeRetornadaPeloBackend(parametros: JornadaPsicologoAntiga): Promise<boolean> {
    const amplo = await lastValueFrom(
      this.psicologoService.getJornadas(
        this.filtros.codigoPolo ?? 0,
        undefined,
        undefined,
        parametros.cpf,
        parametros.dataInicio,
        parametros.dataInicio
      )
    ).catch(() => null);

    if (!amplo?.isSucess || !Array.isArray(amplo.data) || amplo.data.length === 0) {
      return false;
    }

    const fechaInicio = new Date(parametros.dataInicio);
    const fechaFin = new Date(parametros.dataFim);
    const jornadaExistente = (amplo.data as JornadaPsicologo[]).find((j) =>
      jornadasSobrepoemHorario(j, fechaInicio, fechaFin)
    ) ?? (amplo.data as JornadaPsicologo[])[0];

    await this.exibirJornadaConflitanteNaListagem(jornadaExistente, parametros.cpf);
    return true;
  }

  /**
   * #169031 — A validação retroativa busca sem filtro de escola/período da grade.
   * Alinha a pesquisa ao dia do conflito e, só neste momento, mescla busca ampla para exibir a jornada que bloqueou.
   * Não altera o filtro de escola da pesquisa normal (evita “furar” o filtro em toda listagem).
   */
  private async exibirJornadaConflitanteNaListagem(jornada: JornadaPsicologo, cpf?: string | null) {
    const dataRef = new Date(jornada.dataInicio);
    if (Number.isNaN(dataRef.getTime())) {
      return;
    }

    const dia = formatDate(dataRef, 'yyyy-MM-dd', 'pt-BR');
    this.formPesquisar.patchValue({
      dataInicio: dia,
      dataFim: dia
    }, { emitEvent: false });

    if (cpf) {
      this.cpfPsicologoSelecionado = cpf;
      if (this.userLogado?.codigoPerfil !== Perfil.Psicólogo) {
        this.formPesquisar.get('codigoCPF')?.setValue(cpf);
      }
    }

    await this.OnPesquisar();

    const parametros = this.SetParametrosPesquisa();
    const cpfBusca = cpf || parametros.cpf;
    if (!cpfBusca) {
      return;
    }

    const amplo = await lastValueFrom(
      this.psicologoService.getJornadas(
        parametros.codigoPolo ?? 0,
        undefined,
        undefined,
        cpfBusca,
        parametros.dataInicio,
        parametros.dataFim,
        true,
        parametros.psicologosInativos
      )
    ).catch(() => null);

    if (!amplo?.isSucess || !Array.isArray(amplo.data)) {
      return;
    }

    const extras = (amplo.data as JornadaPsicologo[]).map(item => this.normalizarJornadaListagem(item));
    this.lstPainelAtividadePsicologos = mesclarJornadasPorCodigo(this.lstPainelAtividadePsicologos, extras)
      .sort((a, b) => this.getAprovacaoOrder(a) - this.getAprovacaoOrder(b));
    this.forcarAtualizacaoGridAcoes();
  }

  private OnClickAcao(e: any, cell: any) {
    // Evento de click na célula para capturar os botões
    const row = cell.getRow().getData(); // Dados da linha
    const target = e.target; // Elemento clicado
    const codigoAtividade = row.codigoAtividade

  }

  public closeModalJustificativaCheckinOutPsicologo() {
    this.showModalJustificativaCheckinOutPsicologo = false;
  }

  public async closeModalAdicionarJornada(recarregarListagem: boolean = true) {
    // Si hay una sección de deslocamento activa, cerrarla primero
    if (this.showSectionDeslocamento) {
      this.cerrarDeslocamento();
    }

    // Remover la clase expandido del modal antes de cerrar
    const modalContent = document.querySelector('app-modal .modal-content');
    if (modalContent) {
      modalContent.classList.remove('expandido');
    }

    this.showModalAdicionarJornada = false;
    this.showModalJornadaAtividades = false;
    if (recarregarListagem) {
      await this.OnPesquisar();
    }
  }

  public async AbrirVisualizar(item: JornadaPsicologo) {
    let distanciaNumerica: number | undefined;
    if (item.distanciaEscolaInicio) {
      distanciaNumerica = Number(item.distanciaEscolaInicio.slice(0, -2));
    }

    this.router.navigate(['registro-saida'],
      { queryParams: { jornada: item.codigoJornada } });
  }

  public async AbrirJustificativaDistancia(item: JornadaPsicologo) {
    this.showModalJustificativaDistancia = true;
    this.itemJustificativaDistancia = item;
    this.qtdeCaracteresDescricao = 0;
    this.formJustificativaDistancia.get('JustificativaDistancia')?.setValue(item.justificativaDistancia);
    this.formJustificativaDistancia.get('JustificativaDistancia')?.disable();
  }

  public async AbrirJustificativaTempoRegistroAtividade(item: JornadaPsicologo) {
    this.showModalJustificativaTempoRegistroAtividade = true;
    this.itemJustificativaTempoRegistroAtividade = item;
    this.qtdeCaracteresDescricao = 0;
    this.formJustificativaTempoRegistroAtividade.get('justificativaTempoRegistroAtividade')?.setValue(item.justificativaTempoRegistroAtividade);
    this.formJustificativaTempoRegistroAtividade.get('justificativaTempoRegistroAtividade')?.disable();
  }

  public closeModalJustificativaTempoRegistroAtividade() {
    this.showModalJustificativaTempoRegistroAtividade = false;
  }

  public closeModalJustificativaDistancia() {
    this.showModalJustificativaDistancia = false;
  }

  public async AbrirAprovacao(item: JornadaPsicologo) {
    if (!this.lstPainelAtividadePsicologos.find(x => x.codigoJornada == item.codigoJornada)?.atividades.some(x => x.statusAprovacao != 0)) {
      this.toastr.warning("Nenhuma atividade enviada para aprovação", "Atenção");
      return;
    }
    this.router.navigate(['painel-atividade-psicologo', 'aprovacao-atividades'],
      {
        queryParams: { jornada: item.codigoJornada },
        state: { jornada: item },
      });
  }

  public async AbrirVisualizarDetalhe(codigoJornada: number, codigoJornadaAtividade: number) {
    this.router.navigate(['registro-saida', 'jornada'],
      { queryParams: { id: codigoJornada, atividade: codigoJornadaAtividade } });
  }

  public async AbrirAprovacaoDetalhe(codigoJornada: number, codigoJornadaAtividade: number) {

    if (!this.lstPainelAtividadePsicologos.find(x => x.codigoJornada == codigoJornada)?.atividades.some(x => x.codigoAtividade == codigoJornadaAtividade && x.statusAprovacao != 0)) {
      this.toastr.warning("Atividade não enviada para aprovação", "Atenção");
      return;
    }

    const jornada = this.lstPainelAtividadePsicologos.find(x => x.codigoJornada == codigoJornada);
    this.router.navigate(['painel-atividade-psicologo', 'aprovacao-atividades'],
      {
        queryParams: { jornada: codigoJornada, atividade: codigoJornadaAtividade },
        state: { jornada },
      });
  }

  public popularPsicologo() {
    const cpfSelecionado = this.formPesquisar.get('codigoCPF')?.value;
    const psicologoSelecionado = this.lstPsicologos.find(p => cpfsIguais(p.codigoCPF, cpfSelecionado));
    sessionStorage.setItem('painelPsicologo_filtroCpf', psicologoSelecionado?.codigoCPF ?? cpfSelecionado);

    if (psicologoSelecionado) {

      if (this.userLogado) {
        this.userLogado.filtroCpf = psicologoSelecionado.codigoCPF.toString();
        this.authService.setUser(this.userLogado);
        this.permiteInserirJornada = true;
        this.cpfPsicologoSelecionado = psicologoSelecionado.codigoCPF.toString();
      }
    }
    else {
      if (this.userLogado) {
        this.userLogado.filtroCpf = undefined;
        this.authService.setUser(this.userLogado);

        // Psicólogo logado: não depende do combo — CPF vem do login; evita botão retroativo desabilitado.
        if (this.userLogado.codigoPerfil === Perfil.Psicólogo && this.userLogado.cpf) {
          const psicologoLogado = this.lstPsicologos.find(p => cpfsIguais(p.codigoCPF, this.userLogado?.cpf));
          this.cpfPsicologoSelecionado = this.userLogado.cpf;
          this.permiteInserirJornada = true;
          if (psicologoLogado) {
            this.formPesquisar.get('codigoCPF')?.setValue(psicologoLogado.codigoCPF, { emitEvent: false });
          }
        } else {
          this.permiteInserirJornada = false;
          this.cpfPsicologoSelecionado = '';
        }
      }
    }
  }

  OnChangeCountLetters(tipoModal: number) {
    if (tipoModal == 1) {
      const descricao = this.formJustificativaTempoRegistroAtividade.get('justificativaTempoRegistroAtividade')!.value;
      if (descricao != null)
        this.qtdeCaracteresDescricao = descricao.length;
    }
    if (tipoModal == 2) {
      const descricao = this.formJustificativaDistancia.get('JustificativaDistancia')!.value;
      if (descricao != null)
        this.qtdeCaracteresDescricao = descricao.length;
    }
    if (tipoModal == 3) {
      const descricao = this.formJustificativaCheckinOut.get('JustificativaCheckin')!.value;
      if (descricao != null)
        this.qtdeCaracteresDescricao = descricao.length;
    }
    if (tipoModal == 4) {
      const descricao = this.formAdicionarJornada.get('JustificativaSolicitacao')!.value;
      if (descricao != null){
        this.qtdeCaracteresDescricao = descricao.length;
        this.validacaoMostrarBotaoDeslocamento();
      }
    }
    if (tipoModal == 5) {
      const descricao = this.formJustificativaCheckinOut.get('JustificativaCheckout')!.value;
      if (descricao != null)
        this.qtdeCaracteresDescricaoOut = descricao.length;
    }
  }

  public validacaoMostrarBotaoDeslocamento(){
    if(this.qtdeCaracteresDescricao >= 10){
      if(this.validaJornadaAnterior() && this.ultimaJornadaRegistrada != null){
        this.showBotonDeslocamento = true;
      }else{
        this.showBotonDeslocamento = false;
      }
    }
  }

  public async OnPesquisar() {
    this.spinnerService.show();
    this.submitted = true;
    this.userLogado = this.authService.getUser();

    if (!this.filtros && !this.parametroCdDiretoria && !this.parametroCdEscola) {
      this.spinnerService.hide();
      return;
    }

    try {
      const parametros = this.SetParametrosPesquisa();

      if (parametros.codigoPolo == null || parametros.codigoPolo == 0) {
        this.toastr.warning("Polo e Diretoria são obrigatórios.");
        this.spinnerService.hide();
        return;
      }

      if (parametros.codigoDiretoria == null || parametros.codigoDiretoria == 0) {
        this.toastr.warning("Diretoria é obrigatório.");
        this.spinnerService.hide();
        return;
      }


      const result = await lastValueFrom(this.psicologoService.getJornadas(parametros.codigoPolo, parametros.codigoDiretoria, parametros.codigoEscola, parametros.cpf, parametros.dataInicio, parametros.dataFim, true, parametros.psicologosInativos));
      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        return;
      }

      let jornadas = (result.data as JornadaPsicologo[]).map(item => this.normalizarJornadaListagem(item));

      const jornadasOrdenadas = jornadas.sort((a, b) => {
        const sortA = this.getAprovacaoOrder(a);
        const sortB = this.getAprovacaoOrder(b);
        return sortA - sortB;
      });

      if (parametros.cpf && parametros.cpf.length > 0) {
        this.cpfPsicologoSelecionado = parametros.cpf;
      }

      await this.carregarJornadaAtivaPsicologo(jornadasOrdenadas);

      // #155893 — Com filtro de Escola, GetJornadas pode excluir jornada em aberto na URE (sem escola).
      // Só injeta a jornada ativa se for URE (escola 0) ou a mesma escola do filtro —
      // não misturar jornada de OUTRA escola (filtro parecia “não funcionar”).
      const comFiltroEscola = !!(parametros.codigoEscola && Number(parametros.codigoEscola) > 0);
      const referenciaListagem = jornadasOrdenadas[0];
      let listagemFinal = jornadasOrdenadas;

      if (comFiltroEscola && this.jornadaAtivaPsicologo) {
        const escolaAtiva = Number(this.jornadaAtivaPsicologo.codigoEscola ?? 0);
        const escolaFiltro = Number(parametros.codigoEscola);
        if (escolaAtiva === 0 || escolaAtiva === escolaFiltro) {
          listagemFinal = mesclarJornadaAtivaNaListagem(
            jornadasOrdenadas,
            this.enriquecerJornadaAtivaParaListagem(this.jornadaAtivaPsicologo, referenciaListagem)
          );
        }
      }

      this.lstPainelAtividadePsicologos = listagemFinal;
      // #155893 — Redesenha a coluna Ações após sincronizar jornada ativa com a listagem filtrada.
      this.forcarAtualizacaoGridAcoes();

      if (this.lstPainelAtividadePsicologos.length == 0) {
        this.toastr.info('Nenhum registro encontrado.');
        return;
      }
    } catch (err) {
      await this.ConvivaErrors.handleResultError(err);
    } finally {
      this.spinnerService.hide();
    }
  }

  public async listeningFiltroEmitter(eventFilter: FiltroPadrao) {
    this.setFilters(eventFilter);
    this.filtroService.atualizaFiltro(eventFilter);
    this.resetPathParams();

    this.formPesquisar.patchValue({
      codigoPolo: eventFilter.codigoPolo ?? null,
      codigoDiretoria: eventFilter.codigoDiretoria ?? null,
      codigoEscola: eventFilter.codigoEscola ?? null
    }, { emitEvent: false });

    const dataInicio = this.formPesquisar.get('dataInicio')?.value;
    const dataFim = this.formPesquisar.get('dataFim')?.value;

    if (dataInicio == "" || dataInicio == "null") {
      this.formPesquisar.get('dataInicio')?.setValue(null);
    }

    if (dataFim == "" || dataFim == "null") {
      this.formPesquisar.get('dataFim')?.setValue(null);
    }

    sessionStorage.setItem('painelPsicologo_dataInicio', dataInicio || null);
    sessionStorage.setItem('painelPsicologo_dataFim', dataFim || null);

    await this.OnPesquisar();
  }

  setFilters(event: FiltroPadrao) {
    this.filtros = event;
    this.filtros.codigoDiretoria = this.parametroCdDiretoria ?? this.filtros.codigoDiretoria;
    this.filtros.codigoEscola = this.parametroCdEscola ?? this.filtros.codigoEscola;
  }

  resetPathParams() {
    this.parametroCdDiretoria = null;
    this.parametroCdEscola = null;
  }

  public SetParametrosPesquisa(): PainelAtividadePsicologo {
    const filtros = this.filtros ?? new FiltroPadrao();
    const valoresFormulario = this.formPesquisar.getRawValue();
    const painel = new PainelAtividadePsicologo();
    painel.codigoPolo = Number(filtros.codigoPolo ?? valoresFormulario.codigoPolo ?? this.userLogado?.codigoPolo ?? 0);
    painel.codigoDiretoria = this.parametroCdDiretoria ?? filtros.codigoDiretoria ?? valoresFormulario.codigoDiretoria;
    // #171411 — 0 = só URE; null = URE + Escola; >0 = escola. Não converter null em 0.
    painel.codigoEscola = this.resolverCodigoEscolaPesquisa(
      filtros.atividadeDiretoria === true,
      filtros.codigoEscola,
      valoresFormulario.codigoEscola
    );
    painel.cpf = this.userLogado?.codigoPerfil == Perfil.Psicólogo ? this.userLogado?.cpf : valoresFormulario.codigoCPF?.toString();
    painel.dataInicio = valoresFormulario.dataInicio ?? null;
    painel.dataFim = valoresFormulario.dataFim ?? null;
    painel.psicologosInativos = filtros.psicologosInativos ?? false;
    return painel;
  }

  private resolverCodigoEscolaPesquisa(
    atividadeNaUre: boolean,
    codigoFiltro?: number | null,
    codigoFormulario?: number | null
  ): number | null {
    if (this.parametroCdEscola != null && Number(this.parametroCdEscola) > 0) {
      return Number(this.parametroCdEscola);
    }
    const doFiltro = Number(codigoFiltro ?? 0);
    if (doFiltro > 0) {
      return doFiltro;
    }
    const doForm = Number(codigoFormulario ?? 0);
    if (doForm > 0) {
      return doForm;
    }
    // Toggle "Atividade na URE" ativo → CD_ESCOLA = 0 na procedure.
    // Toggle off + escola em branco → NULL (URE e Escola combinadas).
    return atividadeNaUre ? 0 : null;
  }


  public SetParametrosJornada(): JornadaPsicologoAntiga {
    const diretoria = this.diretoriasModal.filter(d => d.codigoDiretoria == this.formAdicionarJornada.value.codigoDiretoriaModal)?.[0];
    const escola = this.escolasModal.filter(e => e.codigoEscola == this.formAdicionarJornada.value.codigoEscolaModal)?.[0];
    const diretoriaOrigem = this.diretoriasOrigem.filter(d => d.codigoDiretoria == this.formAdicionarJornada.value.codigoDiretoriaOrigem)?.[0];
    const escolaOrigem = this.escolasOrigem.filter(e => e.codigoEscola == this.formAdicionarJornada.value.codigoEscolaOrigem)?.[0];
    const { dataCheckIn, dataCheckOut } = this.formAdicionarJornada.value;
    const [dataParte] = dataCheckIn.split('T');
    const [horas, minutos] = dataCheckOut.split(':');
    const dataFimIso = `${dataParte}T${horas.padStart(2, '0')}:${minutos.padStart(2, '0')}`;
    const dataFimDate = new Date(dataFimIso);
    const DataFimLocal = this.formatLocalISO(dataFimDate);
    const painel = new JornadaPsicologoAntiga();
    const psicologo = this.lstPsicologos.find(p => cpfsIguais(p.codigoCPF, this.cpfPsicologoSelecionado));
    painel.codigoDiretoria = diretoria?.codigoDiretoria ?? 0;
    painel.nomeDiretoria = diretoria?.nomeDiretoria ?? '';
    painel.codigoEscola = escola?.codigoEscola ?? 0;
    painel.nomeEscola = escola?.nomeEscola ?? '';
    painel.codigoPsicologo = psicologo?.codigoPsicologo ?? 0;
    painel.nomePsicologo = psicologo?.nomePsicologo ?? '';
    painel.cpf = this.userLogado?.codigoPerfil == Perfil.Psicólogo ? this.userLogado?.cpf : this.cpfPsicologoSelecionado;
    painel.dataInicio = dataCheckIn;
    painel.dataFim = DataFimLocal;
    painel.JustificativaSolicitacao = this.formAdicionarJornada.get('JustificativaSolicitacao')?.value ?? '';
    if(this.showSectionDeslocamento){
      painel.Deslocamento = new AtividadePsicologoDeslocamento();
      painel.Deslocamento.codigoPoloOrigem = this.userLogado?.codigoPolo ?? 0;
      painel.Deslocamento.codigoDiretoriaOrigem = diretoriaOrigem?.codigoDiretoria ?? 0;
      painel.Deslocamento.nomeDiretoriaOrigem = diretoriaOrigem?.nomeDiretoria ?? '';
      painel.Deslocamento.codigoEscolaOrigem = escolaOrigem?.codigoEscola ?? 0;
      painel.Deslocamento.nomeEscolaOrigem = escolaOrigem?.nomeEscola ?? '';
      painel.Deslocamento.codigoPoloDestino = this.userLogado?.codigoPolo ?? 0;
      painel.Deslocamento.codigoDiretoriaDestino = diretoria?.codigoDiretoria ?? 0;
      painel.Deslocamento.nomeDiretoriaDestino = diretoria?.nomeDiretoria ?? '';
      painel.Deslocamento.codigoEscolaDestino = escola?.codigoEscola ?? 0;
      painel.Deslocamento.nomeEscolaDestino = escola?.nomeEscola ?? '';
      painel.Deslocamento.codigoTipoTransporte = this.formAdicionarJornada.get('codigoTipoTransporte')?.value ?? 0;
      painel.Deslocamento.horarioSaida = this.formAdicionarJornada.get('horarioSaida')?.value ?? '';
      painel.Deslocamento.horarioChegada = this.formAdicionarJornada.get('horarioChegada')?.value ?? '';
      painel.Deslocamento.tempoDeslocamento = this.formAdicionarJornada.get('tempoDeslocamento')?.value ?? '';
      painel.Deslocamento.kmPercorrido = this.formAdicionarJornada.get('kmPercorrido')?.value ?? 0;
    }
    return painel;
  }

  public SetParametrosJustificativaTempoRegistro(): JornadaJustificativaTempoRegistro {
    const parametros = new JornadaJustificativaTempoRegistro();
    parametros.codigoJornada = this.itemJustificativaTempoRegistroAtividade.codigoJornada;
    parametros.justificativa = this.formJustificativaTempoRegistroAtividade.get('justificativaTempoRegistroAtividade')?.value ?? '';
    return parametros;
  }

  public SetParametrosJustificativaDistancia(): JornadaJustificativaDistancia {
    const parametros = new JornadaJustificativaDistancia();
    parametros.codigoJornada = this.itemJustificativaDistancia.codigoJornada;
    parametros.justificativa = this.formJustificativaDistancia.get('JustificativaDistancia')?.value ?? '';
    return parametros;
  }

  public formatLocalISO(dt: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    const Y = dt.getFullYear();
    const M = pad(dt.getMonth() + 1);
    const D = pad(dt.getDate());
    const h = pad(dt.getHours());
    const m = pad(dt.getMinutes());
    return `${Y}-${M}-${D}T${h}:${m}`;
  }

  public getDistanciaNumerica(distancia: string | undefined): number {
    if (!distancia) return 0;
    return Number(distancia.slice(0, -2)) || 0;
  }


  validarCPF(cpf: string): boolean {
    cpf = cpf.replace(/[^\d]/g, '');
    if (cpf.length !== 11) {
      return false;
    }
    if (/^(\d)\1+$/.test(cpf)) {
      return false;
    }
    let sum = 0;
    let remainder;
    for (let i = 1; i <= 9; i++) {
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) {
      remainder = 0;
    }
    if (remainder !== parseInt(cpf.substring(9, 10))) {
      return false;
    }
    sum = 0;
    for (let i = 1; i <= 10; i++) {
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) {
      remainder = 0;
    }
    return remainder === parseInt(cpf.substring(10, 11));
  }

  private async filtrarDiretoriasPorAtribuicoesSed(diretorias: Diretoria[], codigoPolo: number): Promise<Diretoria[]> {
    const cpf = (this.cpfPsicologoSelecionado || this.userLogado?.cpf || '').replace(/\D/g, '');
    if (!cpf || (!this.userLogado?.flPsicologo && !this.cpfPsicologoSelecionado)) {
      return diretorias;
    }

    let codigosAtribuidos = new Set<number>();

    // Gestor com psicólogo selecionado: sempre consultar SED (DadosUsuario é do gestor logado).
    const usarDadosLogin = this.userLogado?.flPsicologo && !this.cpfPsicologoSelecionado;
    if (usarDadosLogin) {
      codigosAtribuidos = new Set(
        (this.userLogado?.DadosUsuario ?? [])
          .filter((d) => d.CodigoDiretoria > 0 && Number(d.CodigoPolo) === Number(codigoPolo))
          .map((d) => d.CodigoDiretoria)
      );
    }

    if (codigosAtribuidos.size === 0) {
      const atribuicoes = await lastValueFrom(this.psicologoService.getPsicologoAtribuicoesPorCpf(cpf))
        .catch((err) => this.ConvivaErrors.handleResultError(err));
      const escolas = atribuicoes?.data?.escolas ?? atribuicoes?.data?.Escolas ?? [];
      codigosAtribuidos = new Set(
        escolas.map((e: any) => e.codigoDiretoria ?? e.CodigoDiretoria).filter((c: number) => c > 0)
      );
    }

    if (codigosAtribuidos.size === 0) {
      return diretorias;
    }

    return diretorias.filter((d) => codigosAtribuidos.has(d.codigoDiretoria));
  }

  public async getDiretorias() {
    this.spinnerService.show();
    const codigoPolo = this.filtros?.codigoPolo ?? this.userLogado?.codigoPolo;
    if (!codigoPolo) {
      this.spinnerService.hide();
      return;
    }
    const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(codigoPolo))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    const diretoriasFiltradas = await this.filtrarDiretoriasPorAtribuicoesSed(response.data, codigoPolo);
    this.diretoriasModal = diretoriasFiltradas;
    this.spinnerService.hide();
    if (this.userLogado?.codigoDiretoria != undefined) {
      this.getEscolasModal();
    }
  }

  public async getEscolasModal() {
    this.spinnerService.show();
    this.zerarEscolaModal();
    const codigoDE = this.formAdicionarJornada.value.codigoDiretoriaModal;
    if (codigoDE > 0) {
      if (!this.usuarioLogadoPerfilPsicologo()) {
        const escolasAtribuidas = await this.carregarEscolasAtribuidasSed(codigoDE);
        if (escolasAtribuidas.length > 0) {
          this.escolasModal = escolasAtribuidas;
          this.escolasOrigem = escolasAtribuidas;
          if (escolasAtribuidas.length === 1) {
            this.formAdicionarJornada.get('codigoEscolaModal')?.setValue(escolasAtribuidas[0].codigoEscola);
          }
          this.spinnerService.hide();
          this.validacaoMostrarBotaoDeslocamento();
          return;
        }
      }

      const result = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }
      this.escolasModal = result.data;
      this.escolasOrigem = result.data;
      this.selecionarEscolaModalLogin();
      this.spinnerService.hide();
    } else {
      this.escolasModal = [];
      this.spinnerService.hide();
    }
    this.validacaoMostrarBotaoDeslocamento();
  }

  private usuarioLogadoPerfilPsicologo(): boolean {
    return this.userLogado?.flPsicologo === true
      || this.userLogado?.codigoPerfil === Perfil.Psicólogo;
  }

  private selecionarEscolaModalLogin(): void {
    if (this.atividadeDiretoria) {
      return;
    }

    const codigoEscolaLogin = this.userLogado?.codigoEscola ?? 0;
    if (!codigoEscolaLogin) {
      return;
    }

    const escolaLoginExisteNaDiretoria = this.escolasModal
      .some((e) => Number(e.codigoEscola) === Number(codigoEscolaLogin));

    if (escolaLoginExisteNaDiretoria) {
      this.formAdicionarJornada.get('codigoEscolaModal')?.setValue(codigoEscolaLogin);
    }
  }

  private async carregarEscolasAtribuidasSed(codigoDiretoria: number): Promise<Escola[]> {
    const cpf = (this.cpfPsicologoSelecionado || this.userLogado?.cpf || '').replace(/\D/g, '');
    if (!cpf || (!this.userLogado?.flPsicologo && !this.cpfPsicologoSelecionado)) {
      return [];
    }

    const usarDadosLogin = this.userLogado?.flPsicologo && !this.cpfPsicologoSelecionado;
    if (usarDadosLogin) {
      const escolas = (this.userLogado?.DadosUsuario ?? [])
        .filter((d) => d.CodigoDiretoria === codigoDiretoria && d.CodigoEscola > 0)
        .map((d) => {
          const escola = new Escola();
          escola.codigoEscola = d.CodigoEscola;
          escola.nomeEscola = d.NomeEscola;
          escola.codigoDiretoria = d.CodigoDiretoria;
          return escola;
        });
      if (escolas.length > 0) {
        return escolas;
      }
    }

    const atribuicoes = await lastValueFrom(this.psicologoService.getPsicologoAtribuicoesPorCpf(cpf))
      .catch((err) => this.ConvivaErrors.handleResultError(err));
    const escolasSed = atribuicoes?.data?.escolas ?? atribuicoes?.data?.Escolas ?? [];

    return escolasSed
      .filter((e: any) => (e.codigoDiretoria ?? e.CodigoDiretoria) === codigoDiretoria)
      .map((e: any) => {
        const escola = new Escola();
        escola.codigoEscola = e.codigoEscola ?? e.CodigoEscola;
        escola.nomeEscola = e.nomeEscola ?? e.NomeEscola;
        escola.codigoDiretoria = e.codigoDiretoria ?? e.CodigoDiretoria;
        return escola;
      });
  }



  public zerarEscolaModal() {
    this.escolasModal = [];
    this.formAdicionarJornada.value.codigoEscolaModal = null;
  }

  public closeModalJornadaAtividades() {
    this.showModalJornadaAtividades = false;
  }

  toggleModalAprovacao() {
    this.showModalAprovacao = !this.showModalAprovacao;
  }

  public async EnviarAtividades() {
    this.spinnerService.show();
    const atividadesIds = this.jornadaNaoFinalizada?.atividades.map(x => x.codigoAtividade);
    const response = await lastValueFrom(this.psicologoService.setEnviarParaAprovacaoAtividades(atividadesIds!,
      this.userLogado?.codigoUsuario!,
      this.userLogado?.nome!))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.spinnerService.hide();
      this.toastr.error(response.message);
      return;
    }
    this.toggleModalAprovacao();
    this.toastr.success("Atividades enviadas para a aprovação com sucesso!");
    this.spinnerService.hide();
    this.showModalJornadaAtividades = false;
    this.showModalAdicionarJornada = false;
  }

  async redirectToAddAtividade(codigoJornada?: number, jornada?: JornadaPsicologo) {
    if (!this.codigoJornadaAnteriorInserida && !codigoJornada) {
      this.toastr.error('Código da jornada não encontrado');
      return;
    }

    await this.carregarJornadaAtivaPsicologo(this.lstPainelAtividadePsicologos);

    const codigoJornadaAlvo = codigoJornada ?? this.codigoJornadaAnteriorInserida;
    let jornadaAlvo = jornada;

    if (!jornadaAlvo) {
      jornadaAlvo = this.lstPainelAtividadePsicologos.find(x => x.codigoJornada === codigoJornadaAlvo);
    }

    if (!jornadaAlvo) {
      const response = await lastValueFrom(this.psicologoService.getJornadaPorId(codigoJornadaAlvo))
        .catch((err) => this.ConvivaErrors.handleResultError(err));

      if (!response || !response.isSucess) {
        this.toastr.error(response?.message ?? 'Não foi possível validar a jornada.', response?.title ?? 'Atenção');
        return;
      }

      jornadaAlvo = response.data;
    }

    // #162979 — Mesma liberação por jornada do operador usada em AbrirAdicionarJornada.
    if (!this.podeInserirAtividadeNaJornada(jornadaAlvo)) {
      const liberadoPorOperador = this.temPermissaoInserirAtividade(jornadaAlvo)
        && await this.operadorPossuiJornadaEmAberto();
      if (!liberadoPorOperador) {
        this.exibirAlertaRestricaoRegistroAtividade(jornadaAlvo);
        return;
      }
    }

    this.router.navigate(['/registro-saida/adicionar-registro-atividade'], {
      queryParams: { id: codigoJornadaAlvo }
    });
  }

  private getCpfPsicologoParaJornadaAtiva(): string {
    // #155893 — Mesmo CPF usado pelo ícone verde (relogio-ponto) para perfil Psicólogo.
    // Para coordenador, a listagem/merge (#155893) usa o CPF do psicólogo filtrado;
    // o gate de inserção (#162979) valida também o CPF do operador em operadorPossuiJornadaEmAberto.
    const cpf = this.userLogado?.codigoPerfil === Perfil.Psicólogo
      ? this.userLogado?.cpf
      : (this.cpfPsicologoSelecionado || this.formPesquisar.get('codigoCPF')?.value?.toString() || '');

    return (cpf ?? '').replace(/\D/g, '');
  }

  private getCpfOperadorLogado(): string {
    return (this.userLogado?.cpf ?? '').replace(/\D/g, '');
  }

  /** #162979 — Confirma jornada aberta do operador (fonte do ícone verde / backend de atividades). */
  private async operadorPossuiJornadaEmAberto(): Promise<boolean> {
    if (this.codigoJornadaEmAberto != null) {
      return true;
    }

    const cpfOperador = this.getCpfOperadorLogado();
    if (!cpfOperador) {
      return false;
    }

    // Já consultou este CPF em carregarJornadaAtivaPsicologo (sem resultado + fallback listagem).
    if (this.getCpfPsicologoParaJornadaAtiva() === cpfOperador) {
      return false;
    }

    try {
      const response = await lastValueFrom(this.psicologoService.getJornadaEmAberto(cpfOperador));
      return !!(response?.isSucess && extrairCodigoJornada(response.data));
    } catch {
      return false;
    }
  }

  private normalizarJornadaListagem(item: JornadaPsicologo): JornadaPsicologo {
    if (!item.codigoEscola || item.codigoEscola === 0) {
      return {
        ...item,
        nomeEscola: item.nomeDiretoria
      };
    }

    return item;
  }

  private enriquecerJornadaAtivaParaListagem(
    jornada: JornadaPsicologo,
    referencia?: JornadaPsicologo
  ): JornadaPsicologo {
    const normalizada = this.normalizarJornadaListagem(jornada);

    return {
      ...normalizada,
      nomePsicologo: normalizada.nomePsicologo || referencia?.nomePsicologo || '',
      codigoCPF: normalizada.codigoCPF || referencia?.codigoCPF || this.cpfPsicologoSelecionado || this.userLogado?.cpf || '',
    };
  }

  private buscarJornadaAtivaNaListagem(listagem: JornadaPsicologo[]): JornadaPsicologo | undefined {
    return listagem.find(j => jornadaEstaAtiva(j));
  }

  private async carregarJornadaAtivaPsicologo(listagem?: JornadaPsicologo[]): Promise<void> {
    // #155893 — Carrega GetJornadaEmAberto antes da listagem; API autoritativa para check-in aberto.
    // #162979 — Com isSucess e data null, NÃO tratar como definitivo: usar fallback da listagem
    // (mesma regra do painel do coordenador), evitando bloqueio indevido de jornada retroativa.
    const cpf = this.getCpfPsicologoParaJornadaAtiva();
    const listagemReferencia = listagem ?? this.lstPainelAtividadePsicologos;

    if (!cpf) {
      this.aplicarJornadaAtiva(this.buscarJornadaAtivaNaListagem(listagemReferencia));
      return;
    }

    try {
      const response = await lastValueFrom(this.psicologoService.getJornadaEmAberto(cpf));
      if (response?.isSucess && response.data) {
        this.aplicarJornadaAtiva(response.data);
        return;
      }
    } catch {
      // Mantém fallback da listagem quando a API falhar ou retornar sem jornada.
    }

    this.aplicarJornadaAtiva(this.buscarJornadaAtivaNaListagem(listagemReferencia));
  }

  private aplicarJornadaAtiva(jornada?: JornadaPsicologo): void {
    this.jornadaAtivaPsicologo = jornada;
    this.codigoJornadaEmAberto = extrairCodigoJornada(jornada);
  }

  /** Atualiza jornada em aberto após check-in no relógio de ponto. */
  private async sincronizarJornadaAtivaAposCheckin(): Promise<void> {
    // #162971 — retry curto para alinhar liberação de atividades ao status verde do header.
    const maxTentativas = 3;
    for (let tentativa = 1; tentativa <= maxTentativas; tentativa++) {
      await this.carregarJornadaAtivaPsicologo(this.lstPainelAtividadePsicologos);
      if (this.codigoJornadaEmAberto != null) {
        break;
      }
      if (tentativa < maxTentativas) {
        await new Promise(resolve => setTimeout(resolve, 300 * tentativa));
      }
    }

    if (!this.jornadaAtivaPsicologo) {
      return;
    }

    const referencia = this.lstPainelAtividadePsicologos[0];
    this.lstPainelAtividadePsicologos = mesclarJornadaAtivaNaListagem(
      this.lstPainelAtividadePsicologos,
      this.enriquecerJornadaAtivaParaListagem(this.jornadaAtivaPsicologo, referencia)
    );
    this.forcarAtualizacaoGridAcoes();
  }

  private forcarAtualizacaoGridAcoes(): void {
    this.gridAcoesRefreshKey++;
    if (!this.lstPainelAtividadePsicologos?.length) {
      return;
    }

    this.lstPainelAtividadePsicologos = this.lstPainelAtividadePsicologos.map(j => ({ ...j }));
  }

  private perfilExigeJornadaAtivaParaInserirAtividade(): boolean {
    const perfil = this.userLogado?.codigoPerfil;
    return perfil === Perfil.Psicólogo || perfil === Perfil.CoordenadorPsicologo;
  }

  private podeInserirAtividadeNaJornada(jornada?: JornadaPsicologo): boolean {
    if (!this.temPermissaoInserirAtividade(jornada)) {
      return false;
    }

    if (!this.perfilExigeJornadaAtivaParaInserirAtividade()) {
      return true;
    }

    return this.codigoJornadaEmAberto != null;
  }

  private exibirAlertaRestricaoRegistroAtividade(jornada?: JornadaPsicologo): void {
    if (jornadaEstaAprovada(jornada)) {
      this.toastr.warning('Não é permitido adicionar atividades em jornadas aprovadas.');
      return;
    }

    this.toastr.warning('Registro de atividades permitido apenas durante jornada ativa.');
  }

  private exibirAlertaRestricaoInserirJornadaAntiga(): void {
    this.toastr.warning('Registro de jornada retroativa permitido apenas durante a jornada ativa.');
  }

  calculaTotalHorasAtividades() {
    const horario = new Date(0, 0, 0, 0, 0);
    if (this.lstAtividades.length === 0) {
      this.totalHorasAtividades = horario;
      return;
    }
    this.lstAtividades.forEach(atividade => {
      const tempoAtividade = atividade.tempoAtividade;
      const minutos = parseInt(tempoAtividade, 10);
      horario.setMinutes(horario.getMinutes() + minutos);
    })
    this.totalHorasAtividades = horario;
  }

  public onChangeTipoRegistro() {
    if (this.formJustificativaCheckinOut.get('tipoRegistro')?.value != 3) {
      this.formJustificativaCheckinOut.get('JustificativaCheckout')?.clearValidators();
      this.formJustificativaCheckinOut.get('timeCheckinOutSaida')?.clearValidators();
      this.formJustificativaCheckinOut.get('JustificativaCheckout')?.setValue(null);
      this.formJustificativaCheckinOut.get('timeCheckinOutSaida')?.setValue(null);
    } else {
      this.formJustificativaCheckinOut.get('JustificativaCheckout')?.setValidators(Validators.required);
      this.formJustificativaCheckinOut.get('timeCheckinOutSaida')?.setValidators(Validators.required);
    }
  }

  toggleModalExcluirAtividade() {
    this.showModalExcluirAtividade = !this.showModalExcluirAtividade;
  }

  toggleModalExcluirJornada() {
    this.showModalExcluirJornada = !this.showModalExcluirJornada;
  }

  public ModalExcluirJornada() {
    this.showModalExcluirAtividade = false;
    this.showModalExcluirJornada = true;
  }

  public async OnExcluirJornada() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.psicologoService.setExcluirJornada(this.jornadaIdParaExcluir))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinnerService.hide();
      return;
    }

    this.toastr.success("Jornada excluída com sucesso!");
    this.toggleModalExcluirJornada();

    await this.OnPesquisar();

    this.spinnerService.hide();
  }

  async OnExcluirAtividade() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.psicologoService.setExcluirJornadaAtividade(this.codigoJornadaAtividadeExcluir))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinnerService.hide();
      return;
    }

    this.toastr.success("Atividade excluída com sucesso!");
    this.toggleModalExcluirAtividade();

    await this.OnPesquisar();

    this.spinnerService.hide();
  }

  public OnChangeApenasDiretoria() {
    this.atividadeDiretoria = !this.atividadeDiretoria;

    if (this.atividadeDiretoria) {
      this.formPesquisar.get('codigoEscola')?.clearValidators();
      this.formPesquisar.get('codigoEscola')?.setValue(null);

      this.formAdicionarJornada.get('codigoEscolaModal')?.clearValidators();
      this.formAdicionarJornada.get('codigoEscolaModal')?.setValue(null);
    }
    else {
      this.formPesquisar.get('codigoEscola')?.setValidators([Validators.required]);
      this.formPesquisar.get('codigoEscola')?.setValue(this.userLogado?.codigoEscola ?? null);

      this.formAdicionarJornada.get('codigoEscolaModal')?.setValidators([Validators.required]);
      this.formAdicionarJornada.get('codigoEscolaModal')?.setValue(this.userLogado?.codigoEscola ?? null);
    }

    this.formAdicionarJornada.get('codigoEscolaModal')?.updateValueAndValidity();
    this.formPesquisar.get('codigoEscola')?.updateValueAndValidity();

    this.userLogado!.apenasDiretoria = this.atividadeDiretoria;
    this.authService.setUser(this.userLogado!);
    this.validacaoMostrarBotaoDeslocamento();
  }

  public onChangeEscolaModalJornada(){
    this.validacaoMostrarBotaoDeslocamento();
  }

  public calculaTotalHorasTempoRegistro(tempo?: number): Date {
    const horario = new Date(0, 0, 0, 0, 0);
    if (!tempo)
      return horario;

    const minutes = tempo;
    horario.setMinutes(horario.getMinutes() + minutes);

    return horario;
  }

  public fmtHora(iso: string | Date | null | undefined): string {
    if (!iso) return '';
    const d = new Date(iso);
    return isNaN(d.getTime())
      ? ''
      : d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', hour12: false });
  }

  private formatCheckInOutLinha(r: JornadaPsicologo): string {
    if (!r) return '';

    const inicioDate =
      (r.stAjusteAprovacaoEntrada === 1 && r.hrAjusteEntrada)
        ? r.hrAjusteEntrada
        : r.dataInicio;

    const inicio = this.fmtHora(inicioDate);
    if (!inicio) return '';

    let conteudo: string;

    if (!r.dataFim) {
      const fim =
        r.horaFimMasTempoRegistroStr === '00:00'
          ? null
          : r.horaFimMasTempoRegistroStr;
      conteudo = inicio;
      conteudo += fim ? ` - ${fim}` : '';
    } else {
      const fim = r.horaFimMasTempoRegistroStr;
      conteudo = `${inicio} - ${fim}`;
    }

    return conteudo || '';
  }
//#region Deslocamento

  SectionDeslocamento(){
    this.showModalDeslocamento = false;
    this.showSectionDeslocamento = true;

    // Expandir el modal agregando clase al modal-content
    setTimeout(() => {
      const modalContent = document.querySelector('app-modal .modal-content');
      if (modalContent) {
        modalContent.classList.add('expandido');
      }
    }, 100);

    this.getDiretoriasPorPoloOrigem();

    // this.showBotonDeslocamento = false;
    // var data = this.formAdicionarJornada.get('dataCheckIn')?.value;
    // this.router.navigate(['/deslocamento-jornada/', data])
  }

  async getUltimaJornadaFinalizada() {
    this.spinnerService.show();
    const data = this.formAdicionarJornada.get('dataCheckIn')?.value;

    const body: FinalizaJornadaOutroDia = {
      cpf: this.cpfPsicologoSelecionado,
      data: new Date(data)
    }
    const response = await lastValueFrom(this.psicologoService.getJornadaFinalizadaOutroDia(body));
    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinnerService.hide();
      return;
    }
    this.ultimaJornadaRegistrada = response.data;
    // console.log(this.ultimaJornadaRegistrada);
    // if(this.ultimaJornadaRegistrada != null){
    //   this.showBotonDeslocamento = true;
    // }
    this.spinnerService.hide();
    this.validacaoMostrarBotaoDeslocamento();
  }

  public onChangeDataCheckIn() {
    this.formAdicionarJornada.get('dataCheckIn')?.updateValueAndValidity();
    this.getUltimaJornadaFinalizada();
  }

  public onBlurDataCheckIn() {
    this.formAdicionarJornada.get('dataCheckIn')?.markAsTouched();
    this.formAdicionarJornada.get('dataCheckIn')?.updateValueAndValidity();
  }

  private getHojeSemHorario(): Date {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    return hoje;
  }

  private getDataMinimaJornadaRetroativa(): Date | null {
    if (!this.restringeDataRetroativaJornada) {
      return null;
    }

    const dataMinima = this.getHojeSemHorario();
    dataMinima.setDate(dataMinima.getDate() - this.getLimiteDiasJornadaRetroativaVigente());
    return dataMinima;
  }

  public AbrirModalDeslocamento() {
    this.showModalDeslocamento = true;
  }

  public FecharModalDeslocamento() {
    this.showModalDeslocamento = false;
  }

  public toggleDeslocamento() {
    if (this.showSectionDeslocamento) {
      // Si está activo, cerrar y limpiar
      this.cerrarDeslocamento();
    } else {
      // Si no está activo, abrir modal de confirmación
      this.AbrirModalDeslocamento();
    }
  }

  public cerrarDeslocamento() {
    // Remover la clase expandido del modal
    const modalContent = document.querySelector('app-modal .modal-content');
    if (modalContent) {
      modalContent.classList.remove('expandido');
    }

    // Ocultar la sección
    this.showSectionDeslocamento = false;

    // Limpiar los campos del formulario de deslocamento
    this.limpiarCamposDeslocamento();

    // Reiniciar variables del deslocamento
    this.reiniciarVariablesDeslocamento();
  }

  private limpiarCamposDeslocamento() {
    // Limpiar campos del formulario
    this.formAdicionarJornada.get('codigoDiretoriaOrigem')?.setValue(null);
    this.formAdicionarJornada.get('codigoEscolaOrigem')?.setValue(null);
    this.formAdicionarJornada.get('codigoTipoTransporte')?.setValue(null);
    this.formAdicionarJornada.get('horarioSaida')?.setValue(null);
    this.formAdicionarJornada.get('tempoDeslocamento')?.setValue(null);
    this.formAdicionarJornada.get('horarioChegada')?.setValue(null);
    this.formAdicionarJornada.get('kmPercorrido')?.setValue(null);

    // Limpiar validaciones y deshabilitar campos calculados
    this.formAdicionarJornada.get('tempoDeslocamento')?.clearValidators();
    this.formAdicionarJornada.get('horarioChegada')?.clearValidators();
    this.formAdicionarJornada.get('kmPercorrido')?.clearValidators();

    this.formAdicionarJornada.get('tempoDeslocamento')?.disable();
    this.formAdicionarJornada.get('horarioChegada')?.disable();
    this.formAdicionarJornada.get('kmPercorrido')?.disable();

    // Actualizar validaciones
    this.formAdicionarJornada.get('tempoDeslocamento')?.updateValueAndValidity();
    this.formAdicionarJornada.get('horarioChegada')?.updateValueAndValidity();
    this.formAdicionarJornada.get('kmPercorrido')?.updateValueAndValidity();
  }

  private reiniciarVariablesDeslocamento() {
    // Reiniciar variables relacionadas con deslocamento
    this.atividadeDiretoriaOrigem = false;
    this.diretoriasOrigem = [];
    this.escolasOrigem = [];
    this.totalKm = 0;
    this.totalDuration = '';
    this.totalSeg = 0;
    this.gerouRota = false;

    // Ocultar mapa si está visible
    const mapElement = document.getElementById('map');
    if (mapElement) {
      mapElement.style.display = 'none';
    }
  }

public async getDiretoriasPorPoloOrigem() {
  if(this.userLogado?.codigoPolo){

    this.zerarDiretoriaOrigem();
    this.spinnerService.show();

    const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(this.userLogado!.codigoPolo))
                        .catch((err) => {
                          return this.ConvivaErrors.handleResultError(err);
                        });

    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretoriasOrigem = await this.filtrarDiretoriasPorAtribuicoesSed(response.data, this.userLogado!.codigoPolo);
    this.formJornada.codigoDiretoriaOrigem.enable();
    this.ativaDiretoriaOrigem();
    this.spinnerService.hide();
  }

  if(this.userLogado) {
    this.userLogado.codigoDiretoria = this.userLogado.codigoDiretoria == null ? 0 : this.userLogado.codigoDiretoria ;
    this.authService.setUser(this.userLogado);
  }
}

public zerarDiretoriaOrigem() {
  this.diretoriasOrigem = [];
  this.formJornada.codigoDiretoriaOrigem.patchValue(null);
}

public ativaDiretoriaOrigem(){
  if(this.diretoriasOrigem && this.userLogado?.codigoDiretoria != 0) {
    const diretoria = this.diretoriasOrigem.find(s => s.codigoDiretoria == this.userLogado?.codigoDiretoria);
    if(this.userLogado?.codigoDiretoria != undefined  && diretoria){
      this.formJornada.codigoDiretoriaOrigem.setValue(this.userLogado?.codigoDiretoria);
    }
  }
  if(this.userLogado)
      this.authService.setUser(this.userLogado);
}

public async getEscolasPorDiretoriaOrigem(){

  if(this.userLogado) {
    this.userLogado.codigoEscola = this.userLogado.codigoEscola == null ? 0 : this.userLogado.codigoEscola;
    this.authService.setUser(this.userLogado);
  }

  if(this.userLogado?.codigoDiretoria && this.userLogado?.codigoDiretoria > 0) {
    this.spinnerService.show();
    this.zerarEscolaOrigem();

    const response = await lastValueFrom( this.escolaService.getEscolasPorCodigoDiretoria(this.userLogado!.codigoDiretoria))
                        .catch((err) => {
                          return this.ConvivaErrors.handleResultError(err);
                        });

      if(!response.isSucess){
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }

      this.escolasOrigem = response.data;
      this.ativaEscolaOrigem();
      this.spinnerService.hide();
  }
}

public zerarEscolaOrigem() {
  this.escolasOrigem = [];
  this.formJornada.codigoEscolaOrigem.patchValue(null);
}

public ativaEscolaOrigem(){
  if(this.escolasOrigem != undefined && this.userLogado?.codigoEscola != 0) {

    const escola = this.escolasOrigem.find(s=>s.codigoEscola == this.userLogado?.codigoEscola)

    if(this.userLogado?.codigoEscola != undefined  && escola != undefined)
      this.formJornada.codigoEscolaOrigem.setValue(this.userLogado?.codigoEscola);
  }
}

public async gerarRota(){
  this.submitted = true;

  if (this.formJornada.invalid) {
    return;
  }

  this.spinnerService.show();
  try {
    await this.loadMap();
  } catch (error) {
    console.error('Error generando rota:', error);
    this.toastr.error('Erro ao gerar rota. Tente novamente.');
    this.spinnerService.hide();
  }
}

public async loadMap() {

  const code = (this.atividadeDiretoriaOrigem ? 2 : 0) + (this.atividadeDiretoriaDestino ? 1 : 0);

  // Preenche as coordenadas de origem e destino conforme o deslocamento
  switch (code) {
    case 3: // Deslocamento entre duas diretorias
      await this.detalhesDiretoriaOrigemDestino();
      this.latOrigem = +this.diretoriaOrigem.latitude;
      this.lngOrigem = +this.diretoriaOrigem.longitude;
      this.latDestino = +this.diretoriaDestino.latitude;
      this.lngDestino = +this.diretoriaDestino.longitude;

      this.titleOrigem = `<b>Origem</b> <br/> <b>Diretoria</b>: ${this.diretoriaOrigem.nomeDiretoria} <br/> <b>CIE</b>: ${this.diretoriaOrigem.codigoDiretoria}`;
      this.titleOrigemMark = `Origem - Diretoria: ${this.diretoriaOrigem.nomeDiretoria} - CIE: ${this.diretoriaOrigem.codigoDiretoria}`;
      this.titleDestino = `<b>Destino</b> <br/> <b>Diretoria</b>: ${this.diretoriaDestino.nomeDiretoria} <br/> <b>CIE</b>: ${this.diretoriaDestino.codigoDiretoria}`;
      this.titleDestinoMark = `Destino - Diretoria: ${this.diretoriaDestino.nomeDiretoria} - CIE: ${this.diretoriaDestino.codigoDiretoria}`;
      break;

    case 2: // Deslocamento entre D.E e E.E
      await this.detalhesDiretoriaOrigemEscolaDestino();
      this.latOrigem = +this.diretoriaOrigem.latitude;
      this.lngOrigem = +this.diretoriaOrigem.longitude;
      this.latDestino = +this.escolaDestino.latitude;
      this.lngDestino = +this.escolaDestino.longitude;

      this.titleOrigem = `<b>Origem</b> <br/> <b>Diretoria</b>: ${this.diretoriaOrigem.nomeDiretoria} <br/> <b>CIE</b>: ${this.diretoriaOrigem.codigoDiretoria}`;
      this.titleOrigemMark = `Origem - Diretoria: ${this.diretoriaOrigem.nomeDiretoria} - CIE: ${this.diretoriaOrigem.codigoDiretoria}`;
      this.titleDestino = `<b>Destino</b> <br/> <b>Escola</b>: ${this.escolaDestino.nomeEscola} <br/> <b>CIE</b>: ${this.escolaDestino.codigoEscola}`;
      this.titleDestinoMark = `Destino - Escola: ${this.escolaDestino.nomeEscola} - CIE: ${this.escolaDestino.codigoEscola}`;
      break;

    case 1: // Deslocamento entre E.E e D.E
      await this.detalhesEscolaOrigemDiretoriaDestino();
      this.latOrigem = +this.escolaOrigem.latitude;
      this.lngOrigem = +this.escolaOrigem.longitude;
      this.latDestino = +this.diretoriaDestino.latitude;
      this.lngDestino = +this.diretoriaDestino.longitude;

      this.titleOrigem = `<b>Origem</b> <br/> <b>Escola</b>: ${this.escolaOrigem.nomeEscola} <br/> <b>CIE</b>: ${this.escolaOrigem.codigoEscola}`;
      this.titleOrigemMark = `Origem - Escola: ${this.escolaOrigem.nomeEscola} - CIE: ${this.escolaOrigem.codigoEscola}`;
      this.titleDestino = `<b>Destino</b> <br/> <b>Diretoria</b>: ${this.diretoriaDestino.nomeDiretoria} <br/> <b>CIE</b>: ${this.diretoriaDestino.codigoDiretoria}`;
      this.titleDestinoMark = `Destino - Diretoria: ${this.diretoriaDestino.nomeDiretoria} - CIE: ${this.diretoriaDestino.codigoDiretoria}`;
      break;

    case 0: // Deslocamento entre duas escolas
      await this.detalhesEscolaOrigemDestino();
      this.latOrigem = +this.escolaOrigem.latitude;
      this.lngOrigem = +this.escolaOrigem.longitude;
      this.latDestino = +this.escolaDestino.latitude;
      this.lngDestino = +this.escolaDestino.longitude;

      this.titleOrigem = `<b>Origem</b> <br/> <b>Escola</b>: ${this.escolaOrigem.nomeEscola} <br/> <b>CIE</b>: ${this.escolaOrigem.codigoEscola}`;
      this.titleOrigemMark = `Origem - Escola: ${this.escolaOrigem.nomeEscola} - CIE: ${this.escolaOrigem.codigoEscola}`;
      this.titleDestino = `<b>Destino</b> <br/> <b>Escola</b>: ${this.escolaDestino.nomeEscola} <br/> <b>CIE</b>: ${this.escolaDestino.codigoEscola}`;
      this.titleDestinoMark = `Destino - Escola: ${this.escolaDestino.nomeEscola} - CIE: ${this.escolaDestino.codigoEscola}`;
      break;

    default: // Deslocamento entre duas escolas
      await this.detalhesEscolaOrigemDestino();
      this.latOrigem = +this.escolaOrigem.latitude;
      this.lngOrigem = +this.escolaOrigem.longitude;
      this.latDestino = +this.escolaDestino.latitude;
      this.lngDestino = +this.escolaDestino.longitude;

      this.titleOrigem = `<b>Origem</b> <br/> <b>Escola</b>: ${this.escolaOrigem.nomeEscola} <br/> <b>CIE</b>: ${this.escolaOrigem.codigoEscola}`;
      this.titleOrigemMark = `Origem - Escola: ${this.escolaOrigem.nomeEscola} - CIE: ${this.escolaOrigem.codigoEscola}`;
      this.titleDestino = `<b>Destino</b> <br/> <b>Escola</b>: ${this.escolaDestino.nomeEscola} <br/> <b>CIE</b>: ${this.escolaDestino.codigoEscola}`;
      this.titleDestinoMark = `Destino - Escola: ${this.escolaDestino.nomeEscola} - CIE: ${this.escolaDestino.codigoEscola}`;
      break;
  }

  if(this.latOrigem != this.latDestino || this.lngOrigem != this.lngDestino) {
    if(await this.validarLatLong()) {

      this.spinnerService.show();

      const mapOptions = {
        center: { lat: -23.5489, lng: -46.6388 }, // Lat/Long Central SP
        zoom: 9, // Zoom SP
        mapId: "MapaDeslocamento",
      };

      const divMaps = document.getElementById("map");

      if(divMaps){
        divMaps.style.display = 'unset'

        // Bibliotecas google
        const importMaps = await this.mapsService.loader.importLibrary('maps');
        const importMapsRoutes = await this.mapsService.loader.importLibrary('routes');
        const importMapsMarkers = await this.mapsService.loader.importLibrary('marker');

        // Serviços google
        const serviceDisplay = new importMapsRoutes.DirectionsRenderer({suppressMarkers: true});
        const serviceRoute = new importMapsRoutes.DirectionsService();
        const infoWindow = new importMaps.InfoWindow();

        const maps = new importMaps.Map(divMaps, mapOptions)
        serviceDisplay.setMap(maps);

        // Marcador de Origem
        const pinOrigem = new importMapsMarkers.PinElement({background: '#FBBC04'});
        const markerOrigem = new importMapsMarkers.AdvancedMarkerElement({
          gmpDraggable: false,
          map: maps,
          position: this.getLatLong(+this.latOrigem, +this.lngOrigem),
          title: this.titleOrigemMark,
          content: pinOrigem.element
        });
        markerOrigem.addListener('click', () => {
            infoWindow.setContent(this.titleOrigem);
            infoWindow.setPosition(markerOrigem.position);
            infoWindow.open(maps, markerOrigem);
        });

        // Marcador de Destino
        const pinDestino= new importMapsMarkers.PinElement({background: '#00FF7F'});
        const markerDestino = new importMapsMarkers.AdvancedMarkerElement({
          gmpDraggable: false,
          map: maps,
          position: this.getLatLong(+this.latDestino, +this.lngDestino),
          title: this.titleDestinoMark,
          content: pinDestino.element
        });
        markerDestino.addListener('click', () => {
          infoWindow.setContent(this.titleDestino);
          infoWindow.setPosition(markerDestino.position);
          infoWindow.open(maps, markerDestino);
        });

        this.requestRoute.origin = this.getLatLong(+this.latOrigem, +this.lngOrigem);
        this.requestRoute.destination = this.getLatLong(+this.latDestino, +this.lngDestino);
        const tipoTransporte = this.formJornada.codigoTipoTransporte.value;

        switch (tipoTransporte) {
          case 1: {
            this.requestRoute.travelMode = google.maps.TravelMode.BICYCLING;
            break;
          }
          case 2: {
            this.requestRoute.travelMode = google.maps.TravelMode.DRIVING;
            break;
          }
          case 3: {
            this.requestRoute.travelMode = google.maps.TravelMode.TRANSIT;
            break;
          }
          case 4: {
            this.requestRoute.travelMode = google.maps.TravelMode.WALKING;
            break;
          }
          case 5: {
            this.requestRoute.travelMode = 'TWO_WHEELER' as google.maps.TravelMode;
            break;
          }
        }

        // Executando Serviço de Rotas do Google.
        await serviceRoute.route(this.requestRoute, (result, status) => {
          if(status == google.maps.DirectionsStatus.ZERO_RESULTS){
            this.gerouRota = false;
            this.toastr.warning('Houve algum problema ao Gerar a Rota ...');
            this.spinnerService.hide();
          }
          else if (status === google.maps.DirectionsStatus.OK) {
              serviceDisplay.setDirections(result);
              this.gerouRota = true;
              if(result)
                this.resultRoute = result;
          }

        });

        if(this.gerouRota)
          await this.computeTotalDistance(this.resultRoute);
      }

      this.spinnerService.hide();
    }
    else {
      this.gerouRota = false;
      this.toastr.warning('Houve algum problema ao buscar os Detalhes das Lat/Long ...');
      this.toastr.warning(this.msgLatLongInvalida);
    }
  }
  else {
    this.gerouRota = false;
    this.toastr.warning('O Destino tem que ser diferente da Origem ...');
  }
  this.spinnerService.hide();
}

public async detalhesDiretoriaOrigemDestino(){
  const diretoriaOrigem = this.formJornada.codigoDiretoriaOrigem.value;
  const diretoriaDestino = this.formJornada.codigoDiretoriaModal.value;

  this.spinnerService.show();

  const resultDiretoriaOrigem = await lastValueFrom(this.escolaService.getDiretoriaPorCodigo(diretoriaOrigem))
                                    .catch((err) => {
                                      return this.ConvivaErrors.handleResultError(err);
                                    });

  if(!resultDiretoriaOrigem.isSucess){
      this.toastr.error(resultDiretoriaOrigem.message);
      this.spinnerService.hide();
      return;
  }

  this.diretoriaOrigem = resultDiretoriaOrigem.data[0];

  const resultDiretoriaDestino = await lastValueFrom(this.escolaService.getDiretoriaPorCodigo(diretoriaDestino))
                                    .catch((err) => {
                                      return this.ConvivaErrors.handleResultError(err);
                                    });

  if(!resultDiretoriaDestino.isSucess) {
      this.toastr.error(resultDiretoriaDestino.message);
      this.spinnerService.hide();
      return;
  }

  this.diretoriaDestino = resultDiretoriaDestino.data[0];
  this.spinnerService.hide();
}

public async detalhesDiretoriaOrigemEscolaDestino(){
  const diretoriaOrigem = this.formJornada.codigoDiretoriaOrigem.value;
  const escolaDestino = this.formJornada.codigoEscolaModal.value;

  this.spinnerService.show();

  const resultDiretoriaOrigem = await lastValueFrom(this.escolaService.getDiretoriaPorCodigo(diretoriaOrigem))
                            .catch((err) => {
                              return this.ConvivaErrors.handleResultError(err);
                            });

  if(!resultDiretoriaOrigem.isSucess) {
      this.toastr.error(resultDiretoriaOrigem.message);
      this.spinnerService.hide();
      return;
  }

  this.diretoriaOrigem = resultDiretoriaOrigem.data[0];

  const resultEscolaDestino = await lastValueFrom(this.escolaService.getEscolaDetalhes(escolaDestino))
                              .catch((err) => {
                                return this.ConvivaErrors.handleResultError(err);
                              });

  if(!resultEscolaDestino.isSucess){
      this.toastr.error(resultEscolaDestino.message);
      this.spinnerService.hide();
      return;
  }
  this.escolaDestino = resultEscolaDestino.data;
  this.spinnerService.hide();
}

public async detalhesEscolaOrigemDiretoriaDestino(){
  const escolaOrigem = this.formJornada.codigoEscolaOrigem.value;
  const diretoriaDestino = this.formJornada.codigoDiretoriaModal.value;

  this.spinnerService.show();

  const resultEscolaOrigem = await lastValueFrom(this.escolaService.getEscolaDetalhes(escolaOrigem))
                            .catch((err) => {
                              return this.ConvivaErrors.handleResultError(err);
                            });

  if(!resultEscolaOrigem.isSucess){
      this.toastr.error(resultEscolaOrigem.message);
      this.spinnerService.hide();
      return;
  }

  this.escolaOrigem = resultEscolaOrigem.data;

  const resultDiretoriaDestino = await lastValueFrom(this.escolaService.getDiretoriaPorCodigo(diretoriaDestino))
                                    .catch((err) => {
                                      return this.ConvivaErrors.handleResultError(err);
                                    });

  if(!resultDiretoriaDestino.isSucess){
      this.toastr.error(resultDiretoriaDestino.message);
      this.spinnerService.hide();
      return;
  }
  this.diretoriaDestino = resultDiretoriaDestino.data[0];
  this.spinnerService.hide();
}

public async detalhesEscolaOrigemDestino(){
  const escolaOrigem = this.formJornada.codigoEscolaOrigem.value;
  const escolaDestino = this.formJornada.codigoEscolaModal.value;

  this.spinnerService.show();

  const resultEscolaOrigem = await lastValueFrom(this.escolaService.getEscolaDetalhes(escolaOrigem))
                            .catch((err) => {
                              return this.ConvivaErrors.handleResultError(err);
                            });

  if(!resultEscolaOrigem.isSucess){
      this.toastr.error(resultEscolaOrigem.message);
      this.spinnerService.hide();
      return;
  }

  this.escolaOrigem = resultEscolaOrigem.data;
  const resultEscolaDestino = await lastValueFrom(this.escolaService.getEscolaDetalhes(escolaDestino))
                              .catch((err) => {
                                return this.ConvivaErrors.handleResultError(err);
                              });

  if(!resultEscolaDestino.isSucess){
      this.toastr.error(resultEscolaDestino.message);
      this.spinnerService.hide();
      return;
  }
  this.escolaDestino = resultEscolaDestino.data;
  this.spinnerService.hide();
}

public async validarLatLong(): Promise<boolean> {
  this.msgLatLongInvalida = '';

  if(+this.latOrigem != 0 && +this.lngOrigem != 0 && +this.latDestino != 0 && +this.lngDestino != 0){
    return true;
  }

  if(+this.latOrigem == 0 || +this.lngOrigem == 0){
    this.msgLatLongInvalida = `A Origem está com problema na Lat/Long ... `;
  }

  if(+this.latDestino == 0 || +this.lngDestino == 0){
    this.msgLatLongInvalida += `O Destino está com problema na Lat/Long ...`;
  }

  return false;
}

public getLatLong(lat: number, lng: number): google.maps.LatLng{
  return new google.maps.LatLng({lat, lng});
}

public async computeTotalDistance(result: google.maps.DirectionsResult) {
  const myroute = result.routes[0];

  if (!myroute) {
      return;
  }

  this.totalKm = 0;
  this.totalSeg = 0;
  myroute.legs.forEach((element) => {
    if(element.distance && element.duration){
      this.totalKm += element.distance.value;
      this.totalSeg += element.duration.value;
    }
  });

  const hours = Math.floor(this.totalSeg / 3600) < 10 ? (`00${  Math.floor(this.totalSeg / 3600)}`).slice(-2) : Math.floor(this.totalSeg / 3600);
  const minutes = (`00${  Math.floor((this.totalSeg % 3600) / 60)}`).slice(-2);
  this.totalDuration = `${hours  }:${  minutes  }`;
  this.totalKm = parseInt((this.totalKm / 1000).toString());

  this.formAdicionarJornada.get('tempoDeslocamento')?.setValue(this.totalDuration);
  this.formAdicionarJornada.get('kmPercorrido')?.setValue(this.totalKm);

  const response = await lastValueFrom(this.utilsService.calcularHoras(this.formAdicionarJornada.get('horarioSaida')?.value, this.totalDuration))
                      .catch((err) => {
                        return this.ConvivaErrors.handleResultError(err);
                      });

  if(!response.isSucess){
    this.toastr.error(response.message);
    this.spinnerService.hide();
    return;
  }

  this.formAdicionarJornada.get('horarioChegada')?.setValue(response.data);
  this.spinnerService.hide();
}

public async trocaDiretoriaOrigem(){
  const codigoDiretoria = this.formJornada.codigoDiretoriaOrigem.value;

  if(this.userLogado && codigoDiretoria)
  {
    this.userLogado.codigoDiretoria = codigoDiretoria == null ? 0 : codigoDiretoria;
    this.authService.setUser(this.userLogado);
  }

  if(codigoDiretoria && codigoDiretoria > 0)
    await this.getEscolasPorDiretoriaOrigem();
  else{
    this.escolasOrigem = [];
    this.formAdicionarJornada.get('codigoEscolaOrigem')?.setValue(null);
  }

  this.ValidaAtividadeDiretoriaOrigem();
  await this.removerRota();
}

public OnChangeApenasDiretoriaOrigem(){
  this.atividadeDiretoriaOrigem = !this.atividadeDiretoriaOrigem;
  this.ValidaAtividadeDiretoriaOrigem();
}

public async removerRota() {
  this.gerouRota = false;

  this.formAdicionarJornada.get('horarioChegada')?.setValue(null);
  this.formAdicionarJornada.get('tempoDeslocamento')?.setValue(null);
  this.formAdicionarJornada.get('kmPercorrido')?.setValue(null);

  const divMaps = document.getElementById("map");
  if(divMaps) {
    divMaps.innerHTML = ''; // Limpa a div do maps.
    divMaps.style.display = 'none'
  }
}


public async trocaHoraSaida(){
  const horaSaida = this.formAdicionarJornada.get('horarioSaida')?.value;

  if(this.gerouRota){
    const response = await lastValueFrom(this.utilsService.calcularHoras(horaSaida, this.totalDuration))
                        .catch((err) => {
                          return this.ConvivaErrors.handleResultError(err);
                        });

    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.formAdicionarJornada.get('horarioChegada')?.setValue(response.data);
  }
}

public ValidaAtividadeDiretoriaOrigem() {
  if(this.atividadeDiretoriaOrigem){
    this.formAdicionarJornada.get('codigoEscolaOrigem')?.clearValidators();
    this.formAdicionarJornada.get('codigoEscolaOrigem')?.setValue(null);
    this.formAdicionarJornada.get('codigoEscolaOrigem')?.disable();
  }else{
    this.formAdicionarJornada.get('codigoEscolaOrigem')?.setValidators([Validators.required]);
    this.formAdicionarJornada.get('codigoEscolaOrigem')?.setValue(this.userLogado?.codigoEscola ?? null);
    this.formAdicionarJornada.get('codigoEscolaOrigem')?.enable();
  }

  this.formAdicionarJornada.get('codigoEscolaOrigem')?.updateValueAndValidity();
}

//#endregion Deslocamento

  public async getDatas() {
    const dataInicioSessao = sessionStorage.getItem('painelPsicologo_dataInicio');
    const dataFimSessao = sessionStorage.getItem('painelPsicologo_dataFim');

    if (dataInicioSessao != "") {
      this.formPesquisar.get('dataInicio')?.setValue(dataInicioSessao);
    }

    if (dataFimSessao != "") {
      this.formPesquisar.get('dataFim')?.setValue(dataFimSessao);
    }
  }

  //#region Configurações de Permissões
  public perfisQuePodemAprovar: Perfil[] =
    [
      Perfil.GestorConviva,
      Perfil.FiscalPsicologo,
      Perfil.PEC
    ];

  public perfisQuePodemAprovarDetalhe: Perfil[] =
    [
      Perfil.CoordenadorPsicologo,
      Perfil.FiscalPsicologo,
      Perfil.PEC
    ];

  public perfisJustificativaTempoRegistroAtividade: Perfil[] =
    [
      // Perfil.GestorConviva,
      // Perfil.FiscalPsicologo,
      // Perfil.PEC
    ];

  public perfisJustificativaHorarioPsicologo: Perfil[] =
    [
      Perfil.GestorConviva,
      Perfil.Psicólogo,
      Perfil.GestorConviva
    ];

  public perfisJustificativaHorarioPsicologoFiscal: Perfil[] =
    [
      Perfil.GestorConviva,
      Perfil.CoordenadorPsicologo
    ];

  public perfisJustificativaDistancia: Perfil[] =
    [
      Perfil.GestorConviva,
      Perfil.FiscalPsicologo,
      Perfil.PEC
    ];

  public perfisInserirAtividade: Perfil[] =
    [
      Perfil.GestorConviva,
      Perfil.Psicólogo,
    ];

  public perfisExcluirJornada: Perfil[] =
    [
      Perfil.GestorConviva,
      Perfil.Psicólogo,
    ];

  public perfilGestorConviva: Perfil[] =
    [
      Perfil.GestorConviva
    ];

  public perfisEditarAtividade: Perfil[] =
    [
      Perfil.GestorConviva,
      Perfil.Psicólogo,
    ];

  public perfisExcluirAtividade: Perfil[] =
    [
      Perfil.GestorConviva,
      Perfil.Psicólogo,
    ];

  public perfisQuePodemInserirJornadasRetroativas: Perfil[] =
    [
      Perfil.GestorConviva,
      Perfil.CoordenadorPsicologo,
      Perfil.Psicólogo
    ];
  // #endregion

}
